var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngLogo2025(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 517.7 114.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d2088;}.cls-2{fill:#d7063b;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-8);}.cls-11{fill:url(#linear-gradient-9);}.cls-12{fill:url(#linear-gradient-10);}.cls-13{fill:url(#linear-gradient-11);}.cls-14{fill:url(#linear-gradient-12);}.cls-15{fill:url(#linear-gradient-13);}.cls-16{fill:url(#linear-gradient-14);}.cls-17{fill:url(#linear-gradient-15);}.cls-18{fill:url(#linear-gradient-16);}.cls-19{fill:url(#linear-gradient-17);}.cls-20{fill:url(#linear-gradient-18);}.cls-21{fill:url(#linear-gradient-19);}.cls-22{fill:url(#linear-gradient-20);}.cls-23{fill:url(#linear-gradient-21);}.cls-24{fill:url(#linear-gradient-22);}.cls-25{fill:url(#linear-gradient-23);}.cls-26{fill:url(#linear-gradient-24);}.cls-27{fill:url(#linear-gradient-25);}.cls-28{fill:url(#linear-gradient-26);}.cls-29{fill:url(#linear-gradient-27);}.cls-30{fill:url(#linear-gradient-28);}.cls-31{fill:url(#linear-gradient-29);}.cls-32{fill:url(#linear-gradient-30);}.cls-33{fill:url(#linear-gradient-31);}.cls-34{fill:url(#linear-gradient-32);}.cls-35{fill:url(#linear-gradient-33);}.cls-36{fill:url(#linear-gradient-34);}.cls-37{fill:url(#linear-gradient-35);}.cls-38{fill:url(#linear-gradient-36);}.cls-39{fill:url(#linear-gradient-37);}.cls-40{fill:url(#linear-gradient-38);}.cls-41{fill:url(#linear-gradient-39);}.cls-42{fill:url(#linear-gradient-40);}.cls-43{fill:url(#linear-gradient-41);}.cls-44,.cls-46,.cls-47{fill-rule:evenodd;}.cls-44{fill:url(#linear-gradient-42);}.cls-45{fill:url(#linear-gradient-43);}.cls-46{fill:url(#linear-gradient-44);}.cls-47{fill:url(#linear-gradient-45);}.cls-48{fill:none;}.cls-49{fill:url(#linear-gradient-46);}.cls-50{fill:url(#linear-gradient-47);}.cls-51{fill:url(#linear-gradient-48);}.cls-52{fill:url(#linear-gradient-49);}.cls-53{fill:url(#linear-gradient-50);}.cls-54{fill:url(#linear-gradient-51);}.cls-55{fill:url(#linear-gradient-52);}.cls-56{fill:url(#linear-gradient-53);}.cls-57{fill:url(#linear-gradient-54);}.cls-58{fill:url(#linear-gradient-55);}.cls-59{fill:url(#linear-gradient-56);}.cls-60{fill:url(#linear-gradient-57);}.cls-61{fill:url(#linear-gradient-58);}.cls-62{fill:url(#linear-gradient-59);}.cls-63{fill:url(#linear-gradient-60);}.cls-64{fill:url(#linear-gradient-61);}.cls-65{fill:url(#linear-gradient-62);}.cls-66{fill:url(#linear-gradient-63);}.cls-67{fill:url(#linear-gradient-64);}.cls-68{fill:url(#linear-gradient-65);}.cls-69{fill:url(#linear-gradient-66);}.cls-70{fill:url(#linear-gradient-67);}.cls-71{fill:url(#linear-gradient-68);}.cls-72{fill:url(#linear-gradient-69);}.cls-73{fill:url(#linear-gradient-70);}.cls-74{fill:url(#linear-gradient-71);}.cls-75{fill:url(#linear-gradient-72);}.cls-76{fill:url(#linear-gradient-73);}.cls-77{fill:url(#linear-gradient-74);}.cls-78{fill:url(#linear-gradient-75);}.cls-79{fill:url(#linear-gradient-76);}.cls-80{fill:url(#linear-gradient-77);}.cls-81{fill:url(#linear-gradient-78);}.cls-82{fill:url(#linear-gradient-79);}.cls-83{fill:url(#linear-gradient-80);}.cls-84{fill:url(#linear-gradient-81);}.cls-85{fill:url(#linear-gradient-82);}.cls-86{fill:url(#linear-gradient-83);}.cls-87{fill:url(#linear-gradient-84);}.cls-88{fill:url(#linear-gradient-85);}.cls-89{fill:url(#linear-gradient-86);}.cls-90{fill:url(#linear-gradient-87);}.cls-91{fill:url(#linear-gradient-88);}.cls-92{fill:url(#linear-gradient-89);}.cls-93{fill:url(#linear-gradient-90);}.cls-94{fill:url(#linear-gradient-91);}.cls-95{fill:url(#linear-gradient-92);}.cls-96{fill:url(#linear-gradient-93);}.cls-97{fill:url(#linear-gradient-94);}.cls-98{fill:url(#linear-gradient-95);}.cls-99{fill:url(#linear-gradient-96);}.cls-100{fill:url(#linear-gradient-97);}.cls-101{fill:url(#linear-gradient-98);}.cls-102{fill:url(#linear-gradient-99);}.cls-103{fill:url(#linear-gradient-100);}.cls-104{fill:url(#linear-gradient-101);}.cls-105{fill:url(#linear-gradient-102);}.cls-106{fill:url(#linear-gradient-103);}.cls-107{fill:url(#linear-gradient-104);}.cls-108{fill:url(#linear-gradient-105);}.cls-109{fill:url(#linear-gradient-106);}.cls-110{fill:url(#linear-gradient-107);}.cls-111{fill:url(#linear-gradient-108);}.cls-112{fill:url(#linear-gradient-109);}.cls-113{fill:url(#linear-gradient-110);}.cls-114{fill:url(#linear-gradient-111);}.cls-115{fill:url(#linear-gradient-112);}.cls-116{fill:url(#linear-gradient-113);}.cls-117{fill:url(#linear-gradient-114);}.cls-118{fill:url(#linear-gradient-115);}.cls-119{fill:url(#linear-gradient-116);}.cls-120{fill:url(#linear-gradient-117);}.cls-121{fill:url(#linear-gradient-118);}.cls-122{fill:url(#linear-gradient-119);}.cls-123{fill:url(#linear-gradient-120);}.cls-124{fill:url(#linear-gradient-121);}.cls-125{fill:url(#linear-gradient-122);}.cls-126{fill:url(#linear-gradient-123);}.cls-127{fill:url(#linear-gradient-124);}.cls-128{fill:url(#linear-gradient-125);}.cls-129{fill:url(#linear-gradient-126);}.cls-130{fill:url(#linear-gradient-127);}.cls-131{fill:url(#linear-gradient-128);}.cls-132{fill:url(#linear-gradient-129);}.cls-133{fill:url(#linear-gradient-130);}.cls-134{fill:url(#linear-gradient-131);}.cls-135{fill:url(#linear-gradient-132);}.cls-136{fill:url(#linear-gradient-133);}.cls-137{fill:url(#linear-gradient-134);}.cls-138{fill:url(#linear-gradient-135);}.cls-139{fill:url(#linear-gradient-136);}.cls-140{fill:url(#linear-gradient-137);}.cls-141{fill:url(#linear-gradient-138);}.cls-142{fill:url(#linear-gradient-139);}.cls-143{fill:url(#linear-gradient-140);}.cls-144{fill:url(#linear-gradient-141);}.cls-145{fill:url(#linear-gradient-142);}.cls-146{fill:url(#linear-gradient-143);}.cls-147{fill:url(#linear-gradient-144);}.cls-148{fill:url(#linear-gradient-145);}.cls-149{fill:url(#linear-gradient-146);}.cls-150{fill:url(#linear-gradient-147);}.cls-151{fill:url(#linear-gradient-148);}.cls-152{fill:url(#linear-gradient-149);}.cls-153{fill:url(#linear-gradient-150);}.cls-154{fill:url(#linear-gradient-151);}.cls-155{fill:url(#linear-gradient-152);}.cls-156{fill:url(#linear-gradient-153);}.cls-157{fill:url(#linear-gradient-154);}.cls-158{fill:url(#linear-gradient-155);}.cls-159{fill:url(#linear-gradient-156);}.cls-160{fill:url(#linear-gradient-157);}.cls-161{fill:url(#linear-gradient-158);}.cls-162{fill:url(#linear-gradient-159);}.cls-163{fill:url(#linear-gradient-160);}.cls-164{fill:url(#linear-gradient-161);}.cls-165{fill:url(#linear-gradient-162);}.cls-166{fill:url(#linear-gradient-163);}.cls-167{fill:url(#linear-gradient-164);}.cls-168{fill:url(#linear-gradient-165);}.cls-169{fill:url(#linear-gradient-166);}.cls-170{fill:url(#linear-gradient-167);}.cls-171{fill:url(#linear-gradient-168);}.cls-172{fill:url(#linear-gradient-169);}.cls-173{fill:url(#linear-gradient-170);}.cls-174{fill:url(#linear-gradient-171);}.cls-175{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 214.27,
    y1: 101.44,
    x2: 425.56,
    y2: 98.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e60012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d2088"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 214.29,
    y1: 103.35,
    x2: 425.55,
    y2: 100.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 214.29,
    y1: 103.56,
    x2: 425.59,
    y2: 100.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 214.27,
    y1: 101.6,
    x2: 425.54,
    y2: 98.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 214.26,
    y1: 101.01,
    x2: 425.52,
    y2: 97.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 214.29,
    y1: 102.76,
    x2: 425.56,
    y2: 99.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 214.26,
    y1: 101.23,
    x2: 425.56,
    y2: 98.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 214.3,
    y1: 104.28,
    x2: 425.59,
    y2: 101.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 214.31,
    y1: 104.42,
    x2: 425.58,
    y2: 101.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 214.32,
    y1: 104.65,
    x2: 425.57,
    y2: 101.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 214.29,
    y1: 102.51,
    x2: 425.55,
    y2: 99.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 214.29,
    y1: 103.26,
    x2: 425.57,
    y2: 100.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 214.35,
    y1: 105.12,
    x2: 425.57,
    y2: 102.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 214.33,
    y1: 105.35,
    x2: 425.6,
    y2: 102.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 214.29,
    y1: 103.25,
    x2: 425.57,
    y2: 100.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 214.32,
    y1: 105.73,
    x2: 425.61,
    y2: 102.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 214.35,
    y1: 105.81,
    x2: 425.6,
    y2: 102.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 214.36,
    y1: 108.29,
    x2: 425.64,
    y2: 105.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 214.3,
    y1: 104.54,
    x2: 425.59,
    y2: 101.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 214.32,
    y1: 106.62,
    x2: 425.62,
    y2: 103.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 214.37,
    y1: 106.71,
    x2: 425.62,
    y2: 103.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 214.31,
    y1: 104.61,
    x2: 425.59,
    y2: 101.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 214.32,
    y1: 104.87,
    x2: 425.6,
    y2: 101.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 214.34,
    y1: 105.52,
    x2: 425.61,
    y2: 102.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 214.34,
    y1: 107.57,
    x2: 425.63,
    y2: 104.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 214.39,
    y1: 109.81,
    x2: 425.67,
    y2: 106.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 213.86,
    y1: 73.15,
    x2: 425.13,
    y2: 70.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 213.87,
    y1: 73.61,
    x2: 425.15,
    y2: 70.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 213.87,
    y1: 73.73,
    x2: 425.15,
    y2: 70.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 213.88,
    y1: 74.37,
    x2: 425.16,
    y2: 71.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 213.89,
    y1: 75.34,
    x2: 425.18,
    y2: 72.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 213.91,
    y1: 75.65,
    x2: 425.17,
    y2: 72.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 213.9,
    y1: 76.03,
    x2: 425.18,
    y2: 73.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 213.9,
    y1: 76.57,
    x2: 425.19,
    y2: 73.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 213.92,
    y1: 77.38,
    x2: 425.2,
    y2: 74.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 213.9,
    y1: 77.66,
    x2: 425.2,
    y2: 74.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 213.88,
    y1: 74.66,
    x2: 425.17,
    y2: 71.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 213.94,
    y1: 76.74,
    x2: 425.2,
    y2: 73.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 213.91,
    y1: 77,
    x2: 425.2,
    y2: 73.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 166.25,
    y1: -24.9,
    x2: 166.25,
    y2: 68.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e60012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#431d87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 53.36,
    y1: 28.56,
    x2: 124.95,
    y2: 85.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 22.2,
    y1: 67.69,
    x2: 93.78,
    y2: 124.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 46.28,
    y1: 37.45,
    x2: 117.86,
    y2: 94.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 51.08,
    y1: 31.42,
    x2: 122.67,
    y2: 88.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 47.44,
    y1: 35.99,
    x2: 119.03,
    y2: 93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 26.44,
    y1: 74.03,
    x2: 90.28,
    y2: 124.86,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 26.91,
    y1: 73.43,
    x2: 90.76,
    y2: 124.27,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 29.11,
    y1: 70.68,
    x2: 92.95,
    y2: 121.51,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 28.92,
    y1: 70.91,
    x2: 92.76,
    y2: 121.75,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 27.67,
    y1: 72.49,
    x2: 91.51,
    y2: 123.32,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 29.32,
    y1: 70.41,
    x2: 93.17,
    y2: 121.24,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 25.23,
    y1: 75.55,
    x2: 89.07,
    y2: 126.39,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 28.48,
    y1: 71.46,
    x2: 92.32,
    y2: 122.3,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 26.09,
    y1: 74.47,
    x2: 89.93,
    y2: 125.31,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 26.57,
    y1: 73.86,
    x2: 90.41,
    y2: 124.7,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 25.71,
    y1: 74.94,
    x2: 89.56,
    y2: 125.78,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 25.92,
    y1: 74.67,
    x2: 89.77,
    y2: 125.51,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 24.94,
    y1: 75.91,
    x2: 88.78,
    y2: 126.75,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 24.96,
    y1: 75.89,
    x2: 88.8,
    y2: 126.73,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 25.87,
    y1: 74.74,
    x2: 89.71,
    y2: 125.58,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 26.85,
    y1: 73.51,
    x2: 90.69,
    y2: 124.35,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 28.26,
    y1: 71.74,
    x2: 92.11,
    y2: 122.57,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 26.23,
    y1: 74.28,
    x2: 90.08,
    y2: 125.12,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 27.55,
    y1: 72.63,
    x2: 91.39,
    y2: 123.47,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 27.34,
    y1: 72.9,
    x2: 91.18,
    y2: 123.73,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 26.54,
    y1: 73.89,
    x2: 90.39,
    y2: 124.73,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 26.34,
    y1: 74.16,
    x2: 90.18,
    y2: 124.99,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 24.96,
    y1: 75.88,
    x2: 88.8,
    y2: 126.72,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 27.48,
    y1: 72.72,
    x2: 91.32,
    y2: 123.56,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 26.07,
    y1: 74.49,
    x2: 89.91,
    y2: 125.33,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 26.18,
    y1: 74.35,
    x2: 90.02,
    y2: 125.19,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 25.77,
    y1: 74.87,
    x2: 89.61,
    y2: 125.71,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 25.99,
    y1: 74.6,
    x2: 89.83,
    y2: 125.43,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 26.74,
    y1: 73.65,
    x2: 90.58,
    y2: 124.49,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 25.51,
    y1: 75.19,
    x2: 89.35,
    y2: 126.03,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 25.66,
    y1: 75.01,
    x2: 89.5,
    y2: 125.85,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 25.41,
    y1: 75.31,
    x2: 89.26,
    y2: 126.15,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 25.49,
    y1: 75.22,
    x2: 89.33,
    y2: 126.06,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 25.1,
    y1: 75.71,
    x2: 88.94,
    y2: 126.55,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 27.07,
    y1: 73.23,
    x2: 90.91,
    y2: 124.07,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 26.98,
    y1: 73.34,
    x2: 90.83,
    y2: 124.18,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 26.04,
    y1: 74.53,
    x2: 89.88,
    y2: 125.37,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 25.92,
    y1: 74.67,
    x2: 89.77,
    y2: 125.51,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 26.16,
    y1: 74.38,
    x2: 90,
    y2: 125.22,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 25.77,
    y1: 74.86,
    x2: 89.62,
    y2: 125.7,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 25.59,
    y1: 75.1,
    x2: 89.43,
    y2: 125.94,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 25.56,
    y1: 75.12,
    x2: 89.41,
    y2: 125.96,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 19.81,
    y1: 82.35,
    x2: 83.65,
    y2: 133.19,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 20.07,
    y1: 82.03,
    x2: 83.91,
    y2: 132.86,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 19.74,
    y1: 82.44,
    x2: 83.58,
    y2: 133.28,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 19.93,
    y1: 82.2,
    x2: 83.77,
    y2: 133.04,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 21.95,
    y1: 79.66,
    x2: 85.8,
    y2: 130.5,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 21.78,
    y1: 79.87,
    x2: 85.63,
    y2: 130.71,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 20.55,
    y1: 81.43,
    x2: 84.39,
    y2: 132.26,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 20.4,
    y1: 81.6,
    x2: 84.25,
    y2: 132.44,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 19.92,
    y1: 82.22,
    x2: 83.76,
    y2: 133.06,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 20.29,
    y1: 81.74,
    x2: 84.14,
    y2: 132.58,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 22.06,
    y1: 79.53,
    x2: 85.9,
    y2: 130.37,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 27.6,
    y1: 72.57,
    x2: 91.44,
    y2: 123.41,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 22.23,
    y1: 79.31,
    x2: 45.15,
    y2: 97.56,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 27.43,
    y1: 72.79,
    x2: 91.27,
    y2: 123.63,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 33.38,
    y1: 65.31,
    x2: 97.22,
    y2: 116.15,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 47.16,
    y1: 48.01,
    x2: 111,
    y2: 98.85,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 21.81,
    y1: 79.83,
    x2: 85.66,
    y2: 130.67,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 21.23,
    y1: 80.56,
    x2: 85.08,
    y2: 131.4,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 21.46,
    y1: 80.28,
    x2: 85.3,
    y2: 131.12,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 20.56,
    y1: 81.41,
    x2: 84.4,
    y2: 132.25,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 21.03,
    y1: 80.82,
    x2: 84.88,
    y2: 131.65,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 20.82,
    y1: 81.09,
    x2: 84.66,
    y2: 131.92,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 26.87,
    y1: 73.49,
    x2: 90.71,
    y2: 124.33,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 27.54,
    y1: 72.65,
    x2: 91.38,
    y2: 123.48,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 27.2,
    y1: 73.07,
    x2: 91.04,
    y2: 123.91,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 26.12,
    y1: 74.43,
    x2: 89.96,
    y2: 125.27,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 24.86,
    y1: 76.01,
    x2: 88.71,
    y2: 126.84,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 27.09,
    y1: 73.21,
    x2: 90.93,
    y2: 124.05,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 26.32,
    y1: 74.18,
    x2: 90.16,
    y2: 125.02,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 26.59,
    y1: 73.83,
    x2: 90.44,
    y2: 124.67,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 26.93,
    y1: 73.41,
    x2: 90.78,
    y2: 124.25,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 24.97,
    y1: 75.87,
    x2: 88.81,
    y2: 126.71,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 21.45,
    y1: 80.3,
    x2: 85.29,
    y2: 131.14,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 20.9,
    y1: 80.99,
    x2: 84.74,
    y2: 131.83,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 25.52,
    y1: 75.19,
    x2: 89.36,
    y2: 126.02,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 21.09,
    y1: 80.75,
    x2: 84.93,
    y2: 131.59,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 20.55,
    y1: 81.43,
    x2: 84.39,
    y2: 132.26,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 24.88,
    y1: 75.99,
    x2: 88.72,
    y2: 126.82,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 24.99,
    y1: 75.85,
    x2: 88.83,
    y2: 126.69,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 24.87,
    y1: 75.99,
    x2: 88.72,
    y2: 126.83,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 20.15,
    y1: 81.93,
    x2: 83.99,
    y2: 132.77,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 29.58,
    y1: 70.08,
    x2: 93.42,
    y2: 120.92,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 25.86,
    y1: 74.76,
    x2: 89.7,
    y2: 125.6,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 28.91,
    y1: 70.93,
    x2: 92.75,
    y2: 121.77,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 34.64,
    y1: 63.73,
    x2: 98.48,
    y2: 114.57,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 46.98,
    y1: 48.24,
    x2: 110.82,
    y2: 99.07,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 35.07,
    y1: 63.19,
    x2: 98.91,
    y2: 114.03,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 27.96,
    y1: 72.12,
    x2: 91.8,
    y2: 122.95,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 35.86,
    y1: 62.2,
    x2: 99.7,
    y2: 113.04,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 35.32,
    y1: 62.87,
    x2: 99.16,
    y2: 113.71,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 39.94,
    y1: 57.07,
    x2: 103.78,
    y2: 107.91,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 43.79,
    y1: 52.24,
    x2: 107.63,
    y2: 103.08,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 35.4,
    y1: 62.77,
    x2: 99.24,
    y2: 113.61,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 27.82,
    y1: 72.29,
    x2: 91.67,
    y2: 123.13,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 39.8,
    y1: 57.24,
    x2: 103.65,
    y2: 108.08,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 27.74,
    y1: 72.39,
    x2: 91.58,
    y2: 123.23,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 27.33,
    y1: 72.91,
    x2: 91.17,
    y2: 123.74,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 27.83,
    y1: 72.28,
    x2: 91.67,
    y2: 123.12,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 28.13,
    y1: 71.9,
    x2: 91.98,
    y2: 122.74,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 27.03,
    y1: 73.28,
    x2: 90.88,
    y2: 124.12,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 28.81,
    y1: 71.05,
    x2: 92.66,
    y2: 121.88,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 28.6,
    y1: 71.31,
    x2: 90.76,
    y2: 120.8,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 28.63,
    y1: 71.28,
    x2: 92.47,
    y2: 122.12,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 27.02,
    y1: 73.29,
    x2: 90.87,
    y2: 124.13,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 27.09,
    y1: 73.21,
    x2: 90.93,
    y2: 124.05,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 25.38,
    y1: 75.35,
    x2: 89.23,
    y2: 126.19,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 25.43,
    y1: 75.3,
    x2: 89.27,
    y2: 126.13,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 41.4,
    y1: 55.23,
    x2: 105.25,
    y2: 106.07,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 27.08,
    y1: 73.22,
    x2: 90.93,
    y2: 124.05,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 27.25,
    y1: 73.01,
    x2: 91.09,
    y2: 123.85,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 25.72,
    y1: 74.93,
    x2: 89.56,
    y2: 125.77,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 26.37,
    y1: 74.11,
    x2: 90.21,
    y2: 124.95,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 27.67,
    y1: 72.48,
    x2: 91.51,
    y2: 123.32,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 26.95,
    y1: 73.38,
    x2: 90.79,
    y2: 124.22,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 27.93,
    y1: 72.15,
    x2: 91.78,
    y2: 122.99,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 27.17,
    y1: 73.11,
    x2: 91.01,
    y2: 123.95,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 26.88,
    y1: 73.48,
    x2: 90.72,
    y2: 124.32,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 27.06,
    y1: 73.24,
    x2: 90.91,
    y2: 124.08,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 27.44,
    y1: 72.77,
    x2: 91.28,
    y2: 123.61,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 37.89,
    y1: 59.64,
    x2: 101.74,
    y2: 110.48,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 24.85,
    y1: 76.02,
    x2: 88.69,
    y2: 126.86,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 33.27,
    y1: 65.45,
    x2: 97.11,
    y2: 116.29,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 37.59,
    y1: 60.03,
    x2: 101.43,
    y2: 110.87,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 26.51,
    y1: 73.93,
    x2: 90.36,
    y2: 124.77,
    xlinkHref: "#linear-gradient-40"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uC6B8\uC0B0\uAD81\uB3C4\uB300\uD68C \uC601\uBB38 \uB85C\uACE0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326.9,71.5a6.3,6.3,0,0,0-8.6,1.8h-.1a6.2,6.2,0,0,1-10.4-6.6,12.3,12.3,0,0,0,20.7,13.4h.1l.3-.5A6.3,6.3,0,0,0,326.9,71.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M325,63.1a12.3,12.3,0,0,0-16.9,3.3c-.1.1-.2.2-.2.3h-.1a6.2,6.2,0,0,0,10.4,6.6h.1a6.2,6.2,0,0,1,10.6,6.4A12.5,12.5,0,0,0,325,63.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.3,97.1V93.7H207v3.4h-4.4v12.5h-3.8V97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.7,97.1v3.7h-.9a2.7,2.7,0,0,0-2,.7,3.6,3.6,0,0,0-.7,2.4v5.7h-3.6V97.3h3.4v1.5A4.5,4.5,0,0,1,214.7,97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M225.1,98.5a5.8,5.8,0,0,1,1.5,4.3v6.8h-3.4v-1.4a3.4,3.4,0,0,1-3.3,1.6,3.8,3.8,0,0,1-2.2-.5,3.7,3.7,0,0,1-1.5-1.3,4.1,4.1,0,0,1-.5-1.9,3.5,3.5,0,0,1,1.2-2.8,6.3,6.3,0,0,1,3.7-1h2.3a2.8,2.8,0,0,0-.3-1.3,2.5,2.5,0,0,0-2.1-.7l-1.7.3a3.9,3.9,0,0,0-1.4.8l-1.2-2.8a5.1,5.1,0,0,1,2.2-1.1,7.5,7.5,0,0,1,2.6-.4A5.6,5.6,0,0,1,225.1,98.5Zm-3,8.3a1.8,1.8,0,0,0,.8-1.1v-1.1H221c-1.1,0-1.7.4-1.7,1.3a1,1,0,0,0,.4.9,1.4,1.4,0,0,0,1.1.4A2.8,2.8,0,0,0,222.1,106.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.7,109.6h-3.4v-1.1a4.2,4.2,0,0,1-3.3,1.3,4.6,4.6,0,0,1-2.8-.8,4.3,4.3,0,0,1-2-2.2,6.7,6.7,0,0,1-.8-3.3,7.4,7.4,0,0,1,.8-3.4,4.7,4.7,0,0,1,2-2.2,5.4,5.4,0,0,1,2.8-.8,4.1,4.1,0,0,1,3.1,1.2V92.8h3.6Zm-4.2-3.9a3.6,3.6,0,0,0,.7-2.2,3.9,3.9,0,0,0-.7-2.3,2.5,2.5,0,0,0-1.8-.8,2.6,2.6,0,0,0-1.9.8,3.3,3.3,0,0,0-.7,2.3,3.1,3.1,0,0,0,.7,2.2,2.3,2.3,0,0,0,1.9.9A2.3,2.3,0,0,0,236.5,105.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M243.6,95.2a2,2,0,0,1-.6-1.5,2.1,2.1,0,0,1,2.2-2.2,2.3,2.3,0,0,1,1.6.6,2,2,0,0,1,.6,1.5,2.1,2.1,0,0,1-2.2,2.2A2.1,2.1,0,0,1,243.6,95.2Zm3.4,2.1v12.3h-3.7V97.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M255.9,109.6a3.9,3.9,0,0,1-1.5.2,4.6,4.6,0,0,1-3.2-1.1,4.8,4.8,0,0,1-1.1-3.5v-4.5h-1.7V97.6h1.7v-3h3.6v3h2.6v3.1h-2.6v4.5a1.8,1.8,0,0,0,.3,1.1,1.3,1.3,0,0,0,.9.4,2.1,2.1,0,0,0,1.3-.5l.9,2.9A3.3,3.3,0,0,1,255.9,109.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M258.9,95.2a2,2,0,0,1-.6-1.5,2.1,2.1,0,0,1,2.2-2.2,2.3,2.3,0,0,1,1.6.6,2,2,0,0,1,.6,1.5,2.3,2.3,0,0,1-.6,1.6,2.4,2.4,0,0,1-3.2,0Zm3.4,2.1v12.3h-3.6V97.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M267.2,109a5.8,5.8,0,0,1-2.2-2.2,7.2,7.2,0,0,1,0-6.6,6.1,6.1,0,0,1,2.2-2.3,6.6,6.6,0,0,1,3.2-.8,6.9,6.9,0,0,1,3.2.8,6.1,6.1,0,0,1,2.2,2.3,7.2,7.2,0,0,1,0,6.6,5.8,5.8,0,0,1-2.2,2.2,5.9,5.9,0,0,1-3.2.8A5.7,5.7,0,0,1,267.2,109Zm5-3.3a3.1,3.1,0,0,0,.7-2.2,3.3,3.3,0,0,0-.7-2.3,2.2,2.2,0,0,0-1.8-.8,2.5,2.5,0,0,0-1.8.8,3.3,3.3,0,0,0-.7,2.3,3.1,3.1,0,0,0,.7,2.2,2.2,2.2,0,0,0,3.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M288.9,98.5a6.1,6.1,0,0,1,1.2,4.1v7h-3.6v-6.4c0-1.7-.6-2.6-2-2.6a2.2,2.2,0,0,0-1.7.7,3.7,3.7,0,0,0-.6,2.3v6h-3.7V97.3H282v1.2a3.7,3.7,0,0,1,1.6-1,4.1,4.1,0,0,1,1.9-.4A4.6,4.6,0,0,1,288.9,98.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M301.1,98.5a6.2,6.2,0,0,1,1.4,4.3v6.8h-3.4v-1.4a3.4,3.4,0,0,1-3.3,1.6,4,4,0,0,1-2.2-.5,2.9,2.9,0,0,1-1.4-1.3,3.2,3.2,0,0,1-.5-1.9,3.5,3.5,0,0,1,1.2-2.8,6.1,6.1,0,0,1,3.7-1h2.3a2.8,2.8,0,0,0-.3-1.3,2.9,2.9,0,0,0-2.2-.7,4.5,4.5,0,0,0-1.6.3,2.7,2.7,0,0,0-1.4.8l-1.3-2.8a5.1,5.1,0,0,1,2.2-1.1,7.8,7.8,0,0,1,2.6-.4A6.1,6.1,0,0,1,301.1,98.5Zm-3,8.3a3.1,3.1,0,0,0,.8-1.1v-1.1H297c-1.2,0-1.8.4-1.8,1.3a1,1,0,0,0,.4.9,1.5,1.5,0,0,0,1.1.4A3.3,3.3,0,0,0,298.1,106.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M308.3,92.8v16.8h-3.7V92.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M318.9,106.4l-1.2,3.2h-3.8l6.4-15.9H324l6.3,15.9h-3.9l-1.1-3.2Zm3.2-8.6-2,5.5h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M338.5,97.1v3.7h-.8a2.8,2.8,0,0,0-2.1.7,4.3,4.3,0,0,0-.7,2.4v5.7h-3.6V97.3h3.4v1.5A4.5,4.5,0,0,1,338.5,97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M342.5,109a5.2,5.2,0,0,1-2.2-2.2,7.2,7.2,0,0,1,0-6.6,5.4,5.4,0,0,1,2.2-2.3,6.9,6.9,0,0,1,3.2-.8,5.5,5.5,0,0,1,3.2.9,5.2,5.2,0,0,1,2,2.4l-2.8,1.7a2.6,2.6,0,0,0-2.4-1.7,2.5,2.5,0,0,0-1.8.8,3.3,3.3,0,0,0-.7,2.3,3.1,3.1,0,0,0,.7,2.2,2.3,2.3,0,0,0,1.8.9,2.5,2.5,0,0,0,2.4-1.7l2.8,1.7a5.2,5.2,0,0,1-2,2.4,6.3,6.3,0,0,1-3.2.8A5.9,5.9,0,0,1,342.5,109Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M362.8,98.5a6.1,6.1,0,0,1,1.3,4.1v7h-3.6v-6.4c0-1.7-.7-2.6-2.1-2.6a2.1,2.1,0,0,0-1.7.7,3.7,3.7,0,0,0-.6,2.3v6h-3.7V92.8h3.7v5.6a3.1,3.1,0,0,1,1.5-1,5.7,5.7,0,0,1,1.8-.3A4.6,4.6,0,0,1,362.8,98.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M377.7,104.6h-8.2a2.4,2.4,0,0,0,1,1.5,3,3,0,0,0,1.9.5,3.4,3.4,0,0,0,1.5-.2l1.2-.8,1.9,2.3a5.7,5.7,0,0,1-4.7,1.9,6.3,6.3,0,0,1-3.4-.8,5.8,5.8,0,0,1-2.2-2.2,7.2,7.2,0,0,1,0-6.6,5.8,5.8,0,0,1,2.1-2.3,6.8,6.8,0,0,1,3.1-.8,6.1,6.1,0,0,1,3,.8,5.6,5.6,0,0,1,2.1,2.2,7.8,7.8,0,0,1,.8,3.5Zm-7.4-3.9a2.7,2.7,0,0,0-.8,1.6h4.9a2.8,2.8,0,0,0-.9-1.6,2.1,2.1,0,0,0-1.6-.6A2.3,2.3,0,0,0,370.3,100.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M386.9,97.1v3.7H386a2.7,2.7,0,0,0-2,.7,3.6,3.6,0,0,0-.7,2.4v5.7h-3.6V97.3h3.4v1.5A4.5,4.5,0,0,1,386.9,97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M394,113.3a4.5,4.5,0,0,1-2.8.9l-1.8-.3a2.7,2.7,0,0,1-1.4-.8l1.3-2.8.8.5,1,.2h.6a.5.5,0,0,0,.5-.3,3.6,3.6,0,0,0,.5-.9l-4.8-12.4h3.7l2.9,7.9,2.9-7.9h3.5L396,110.2A6.9,6.9,0,0,1,394,113.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M424.2,109.6h-4l-2.9-10.1-3,10.1h-4.1l-4.6-15.9h3.9l3,10.6,3.1-10.6h3.5l3.1,10.7,3.1-10.7h3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M431.4,109a6.6,6.6,0,0,1-2.2-2.2,7.2,7.2,0,0,1,0-6.6,6.9,6.9,0,0,1,2.2-2.3,7.2,7.2,0,0,1,3.2-.8,6.6,6.6,0,0,1,3.2.8,5.4,5.4,0,0,1,2.2,2.3,7.2,7.2,0,0,1,0,6.6,5.2,5.2,0,0,1-2.2,2.2,5.7,5.7,0,0,1-3.2.8A6.1,6.1,0,0,1,431.4,109Zm5.1-3.3a3.6,3.6,0,0,0,.7-2.2,3.9,3.9,0,0,0-.7-2.3,2.6,2.6,0,0,0-1.9-.8,2.5,2.5,0,0,0-1.8.8,3.9,3.9,0,0,0-.7,2.3,3.6,3.6,0,0,0,.7,2.2,2.3,2.3,0,0,0,1.8.9A2.3,2.3,0,0,0,436.5,105.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M449.9,97.1v3.7h-.8a2.7,2.7,0,0,0-2,.7,3.6,3.6,0,0,0-.7,2.4v5.7h-3.7V97.3h3.5v1.5A4.3,4.3,0,0,1,449.9,97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M455.3,92.8v16.8h-3.6V92.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M469.5,109.6h-3.4v-1.1a4.2,4.2,0,0,1-3.3,1.3,4.6,4.6,0,0,1-2.8-.8,4.8,4.8,0,0,1-2-2.2,6.7,6.7,0,0,1-.8-3.3,7.4,7.4,0,0,1,.8-3.4,5.3,5.3,0,0,1,2-2.2,5.4,5.4,0,0,1,2.8-.8,4,4,0,0,1,3.1,1.2V92.8h3.6Zm-4.2-3.9a3.6,3.6,0,0,0,.7-2.2,3.9,3.9,0,0,0-.7-2.3,2.5,2.5,0,0,0-1.8-.8,2.6,2.6,0,0,0-1.9.8,3.3,3.3,0,0,0-.7,2.3,3.1,3.1,0,0,0,.7,2.2,2.3,2.3,0,0,0,1.9.9A2.3,2.3,0,0,0,465.3,105.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M479.9,108.9a7.4,7.4,0,0,1-2.8-3,8.4,8.4,0,0,1-1-4.2,10.1,10.1,0,0,1,1-4.3,8.1,8.1,0,0,1,2.9-2.9,7.7,7.7,0,0,1,7.4-.3,6.2,6.2,0,0,1,2.6,2.2l-2.4,2.4a4.3,4.3,0,0,0-3.4-1.9,3.8,3.8,0,0,0-2.2.6,3.5,3.5,0,0,0-1.5,1.7,4.9,4.9,0,0,0-.6,2.5,4.8,4.8,0,0,0,.6,2.4,3.1,3.1,0,0,0,1.5,1.7,3.8,3.8,0,0,0,2.2.6,3.9,3.9,0,0,0,3.4-1.9L490,107a7,7,0,0,1-2.6,2.2,7.8,7.8,0,0,1-3.5.7A7.9,7.9,0,0,1,479.9,108.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M502.7,109.6h-3.4v-1.2a4.2,4.2,0,0,1-1.5,1.1,5.7,5.7,0,0,1-1.8.3,4.3,4.3,0,0,1-3.5-1.4,6.2,6.2,0,0,1-1.3-4.2V97.3h3.6v6.3c0,1.9.7,2.8,2,2.8a2.1,2.1,0,0,0,1.7-.8,3.7,3.7,0,0,0,.6-2.3v-6h3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M515,97.9a5.3,5.3,0,0,1,2,2.2,7.4,7.4,0,0,1,.7,3.4,7,7,0,0,1-.7,3.3,4.8,4.8,0,0,1-2,2.2,4.4,4.4,0,0,1-2.8.8,4.1,4.1,0,0,1-3.1-1.2V114h-3.6V97.3h3.4v1.1a4.5,4.5,0,0,1,3.3-1.3A5.1,5.1,0,0,1,515,97.9Zm-1.6,7.8a3.6,3.6,0,0,0,.7-2.2,3.9,3.9,0,0,0-.7-2.3,2.5,2.5,0,0,0-1.8-.8,2.2,2.2,0,0,0-1.8.8,3.4,3.4,0,0,0-.8,2.3,3.6,3.6,0,0,0,.7,2.2,2.3,2.3,0,0,0,1.9.9A2.3,2.3,0,0,0,513.4,105.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M213.4,85.7H195.6V81.5l8.8-8.6a8.1,8.1,0,0,0,1.8-2.3,3.9,3.9,0,0,0,.4-1.8,2.3,2.3,0,0,0-.8-2,3.7,3.7,0,0,0-2.5-.7,5,5,0,0,0-4.4,2.4l-4.4-3a9.7,9.7,0,0,1,3.8-3.4,11.6,11.6,0,0,1,5.6-1.3,10.8,10.8,0,0,1,4.6.9,6.6,6.6,0,0,1,4.2,6.4,8.1,8.1,0,0,1-.8,3.8,13.3,13.3,0,0,1-3,4l-4.8,4.6h9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M219.7,84.6a10.3,10.3,0,0,1-3.6-4.3,16,16,0,0,1-1.3-6.9,15.9,15.9,0,0,1,1.3-6.8,10.3,10.3,0,0,1,3.6-4.3,9.3,9.3,0,0,1,5.2-1.5,9.4,9.4,0,0,1,8.8,5.8,15.9,15.9,0,0,1,1.3,6.8,16,16,0,0,1-1.3,6.9,9.4,9.4,0,0,1-8.8,5.8A9.3,9.3,0,0,1,219.7,84.6Zm8.2-5.6c.7-1.2,1-3,1-5.6a11.2,11.2,0,0,0-1-5.5,3.2,3.2,0,0,0-3-1.7,3.2,3.2,0,0,0-2.9,1.7,11.2,11.2,0,0,0-1,5.5c0,2.6.3,4.4,1,5.6a3.2,3.2,0,0,0,2.9,1.7A3.2,3.2,0,0,0,227.9,79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M254.4,85.7H236.6V81.5l8.8-8.6a8.1,8.1,0,0,0,1.8-2.3,3.9,3.9,0,0,0,.4-1.8,2.6,2.6,0,0,0-.8-2,3.7,3.7,0,0,0-2.5-.7,5.4,5.4,0,0,0-2.5.6,4.7,4.7,0,0,0-1.9,1.8l-4.4-3a9.7,9.7,0,0,1,3.8-3.4,11.3,11.3,0,0,1,5.6-1.3,10.8,10.8,0,0,1,4.6.9,6.6,6.6,0,0,1,4.2,6.4,8.1,8.1,0,0,1-.8,3.8,13.3,13.3,0,0,1-3,4l-4.8,4.6h9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M272.7,72.3a6.9,6.9,0,0,1,2.4,5.5A8.5,8.5,0,0,1,274,82a6.9,6.9,0,0,1-3.3,3,12.8,12.8,0,0,1-5.5,1.1,19.9,19.9,0,0,1-4.9-.6,15.5,15.5,0,0,1-4.1-1.9l2.3-4.8a14.8,14.8,0,0,0,3.1,1.5,13.3,13.3,0,0,0,3.4.5,5.9,5.9,0,0,0,2.9-.7,2.4,2.4,0,0,0,1.1-2,2.5,2.5,0,0,0-1.1-2.1,8.2,8.2,0,0,0-3.8-.7h-6.2l1.2-14.1h14.5v5.1h-9.4l-.3,3.9h1.6Q270.5,70.2,272.7,72.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M348.7,78a7.4,7.4,0,0,0,3.2-3.1,8.8,8.8,0,0,0,1.2-4.6,9,9,0,0,0-1.2-4.8,7.3,7.3,0,0,0-3.4-3.1,10.4,10.4,0,0,0-5.1-1.1h-9.9V85.7h5.8V79.1h3.9l1.7,2.8,2.4,3.8h6.2l-2.3-3.6ZM343,74.1h-3.7V66.4H343a4.9,4.9,0,0,1,3.2,1,3.8,3.8,0,0,1,1.1,2.9,3.8,3.8,0,0,1-1.1,2.8A4.9,4.9,0,0,1,343,74.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "362.2 75.8 372.2 75.8 372.2 70.8 362.2 70.8 362.2 66.4 373.5 66.4 373.5 61.3 356.5 61.3 356.5 82.1 356.5 85.7 373.9 85.7 373.9 81.1 373.9 80.6 362.2 80.6 362.2 75.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M390,61.3h-5.7l-7.9,19.6-1.9,4.8h5.9l1.8-4.9h9.7l1.8,4.9h6l-3.1-8Zm-3,6.2,3.1,8.5H384Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M423.1,72.5v2.1a7.4,7.4,0,0,1-1.2,4.7,3.7,3.7,0,0,1-3.3,1.4,3.8,3.8,0,0,1-3.3-1.4,7.4,7.4,0,0,1-1.2-4.7V61.3h-5.7V75.2c0,3.5.9,6.1,2.7,8s4.2,3,7.5,3a9.6,9.6,0,0,0,7.5-3c1.8-1.9,2.7-4.7,2.7-8.3V61.3h-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M484.4,61.3h-5.7l-3.4,8.5-6.4,15.9h5.9l1.8-4.9h9.8l1.8,4.9h6l-5.9-14.8Zm-6,14.7,2.1-5.9,1-2.6,1,2.8,2,5.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "510.7 61.3 510.7 74.9 500.6 61.3 495.8 61.3 495.8 72 495.8 85.7 501.5 85.7 501.5 73 501.5 72.1 502.2 73.1 511.7 85.7 516.4 85.7 516.4 76.5 516.4 61.3 510.7 61.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "297.4 72.1 306.4 61.3 300 61.3 292.6 70 291 71.9 291 69.3 291 61.3 285.3 61.3 285.3 66.4 285.3 85.7 291 85.7 291 79.6 293.6 76.6 300.2 85.7 306.9 85.7 297.4 72.1 297.4 72.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "438.8 70.6 438.8 61.3 433 61.3 433 71.2 433 85.7 449.6 85.7 449.6 80.5 438.8 80.5 438.8 70.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M467.8,74.4a7.1,7.1,0,0,0-2.8-2.1,23.5,23.5,0,0,0-4.2-1.3,22.6,22.6,0,0,1-3.4-1.1l-.6-.4a1.7,1.7,0,0,1-.5-1.2,2,2,0,0,1,.9-1.7,4.6,4.6,0,0,1,2.9-.7,11.5,11.5,0,0,1,6.2,1.9l1.7-4.9a9.8,9.8,0,0,0-3.6-1.5,15.2,15.2,0,0,0-4.2-.6,13.5,13.5,0,0,0-5.3,1,7.5,7.5,0,0,0-3.2,2.9,6.6,6.6,0,0,0-1.1,3.9v1.1a5.9,5.9,0,0,0,1.2,2.9,7.4,7.4,0,0,0,2.8,2.2,23.5,23.5,0,0,0,4.2,1.3l3.4,1.1a1.8,1.8,0,0,1,1.1,1.7,2,2,0,0,1-1,1.6,5.5,5.5,0,0,1-2.9.6,13.4,13.4,0,0,1-3.9-.7,10.1,10.1,0,0,1-3.4-1.8l-1.9,4.8a10,10,0,0,0,4,2,18.1,18.1,0,0,0,5.1.8,11.9,11.9,0,0,0,5.3-1.1,7.1,7.1,0,0,0,3.3-2.8,7.7,7.7,0,0,0,1.1-3.9A6.2,6.2,0,0,0,467.8,74.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 166,
    y: 60.1,
    width: 0.6,
    height: 49.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M74.2,39.8A6.8,6.8,0,1,1,67.4,33,6.8,6.8,0,0,1,74.2,39.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M24.3,45.7s76.6,11.2,5.3,63C29.6,108.7,87.4,63.6,24.3,45.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M77.1,4.8l-3.6,1c-51.2,14.4-83,51-71,81.8C5.8,96,12,103.1,20.3,108.7h.2a44,44,0,0,1-8.9-11.3C-4.1,67.8,22.9,28.5,72.1,9.7L78,7.5A150.4,150.4,0,0,1,114.9,0,153,153,0,0,0,77.1,4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M25.6,43.9a481.6,481.6,0,0,1,60.8,8.7c32.6,6.8,24.5-7.2,3.1-12.8,0,0,37.9,8.8,27.8,18.8C104.6,71,76.1,51.1,25.6,43.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M76.7,64.1s31.6,14.3,52,44.6h18.2S111.7,73.3,76.7,64.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M59.7,90.8h.2c-.1-.3,0-.3.1-.6a.4.4,0,0,0,.1-.3.2.2,0,0,0,.2-.2h-.2a.3.3,0,0,0-.1.2h-.1l-.2.5c0,.1-.1.3-.1.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M60.5,89.3l.3-.3.4-.5V88H61a.4.4,0,0,1-.1.3v.2l-.2.2v.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M58.4,94.7c-.1,0-.1.1-.2.2l-.6.3h0V95c.1-.1.1-.5.4-.5h.1c0-.1,0-.2.1-.2l.2-.2c0-.1-.2-.4-.2-.5v-.4h0a.6.6,0,0,0-.1.4l-.2.5h-.1l-.3.5c-.1.2-.1.4-.2.5L57,96v.3c.1,0,0,.2-.1.3l.3-.3h0l.2-.2v-.2h0l.2-.3h.2l.7-.9C58.5,94.5,58.4,94.4,58.4,94.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M48.7,104.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M60.8,89.3h.5c.2.2.4.2.5.4h0c-.1-.5-.1-1-.2-1.4a.4.4,0,0,1-.1-.3l-.2-.2a1.1,1.1,0,0,1-.3,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M48.1,105h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M61.6,90.1a.3.3,0,0,0,.1.2h0A.1.1,0,0,0,61.6,90.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M104.6,91.5c-.1-.3-.1-.8-.4-.8v-.2l-.3-.2h0c0-.3-.2-.4-.3-.6l-.2-.5c-.1-.1-.3-.1-.3-.3s-.4-1.1-.8-1.1l.2.2h0a.5.5,0,0,0-.2.4c.8,1.1,1.7,2.2,2.4,3.3h0C104.7,91.6,104.6,91.6,104.6,91.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M61.6,90.5h0c0-.1-.2-.4-.1-.4h-.2l-.2.2a.6.6,0,0,1-.1-.4v-.2l-.5-.2h-.2c.3,0,.1.3,0,.4v.3l-.2.2h0c.2.1.4.4.6.1h0c.2.1.1.3.2.3h.1l.2-.2c0,.1.1.3-.1.4H59.6c.2-.2,1.1,0,1.5.2l.6-.8h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M65,105.7h.1a3.4,3.4,0,0,1,.1-1,4.3,4.3,0,0,0,.1-.5V104a.4.4,0,0,0-.1.3.6.6,0,0,1-.1.4v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M65,104.4c0-.2.1-.3.1-.4v-.4c0-.1.1-.2.1-.3a.8.8,0,0,0-.2.4v.2a.9.9,0,0,0-.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M64.9,99.1h-.2S64.9,99.2,64.9,99.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M65,99.6v.2c.1.1,0,.1,0,.2s.1.1.1.2h0c0-.1.1-.1.1-.3s-.2-.4-.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M65.2,100.9v.5c0,.2.1.4.1.6a.4.4,0,0,0-.1.3v.9h0c.2,0,0,.5,0,.6h.2a.5.5,0,0,0,.2-.4h0c-.1.1-.1.3-.2.3h0c-.1-.2,0-.3,0-.4a.5.5,0,0,1,0-.6c-.1-.2-.2-.6,0-.8h0a.8.8,0,0,0-.1-.4h-.1C65.2,101.2,65.3,101.1,65.2,100.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M64.9,98.7h0a.1.1,0,0,0-.1.1h.1c0-.1.1-.1.2-.2h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M65.1,107.2s-.1.2,0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M64.6,100.3h0c0-.1.1-.2-.1-.3v.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M64.8,106.1a7.6,7.6,0,0,0,.1-1.5c0,.2-.1.5-.1.7v.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M65.6,104.8v.2h0c0-.1.1-.1.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M65,106.6h0c0-.2.1-.4.1-.7S65,106.4,65,106.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M65.1,105.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M65,107.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M65,107.5l-.2.3H65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M65.4,106.6c.1-.4.3-.5.2-1s-.1.4-.2.5a1.4,1.4,0,0,1-.2.6h0C65.3,106.7,65.3,106.6,65.4,106.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M65.5,104.5a.9.9,0,0,0,0-.7v.3c-.1,0-.1.1-.1.2v.4h.1c0,.1,0,.1.1.2h0v-.4h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M64.6,100.9h0v-.5c-.1.1-.1.5,0,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M65.4,105.9h0v-.5c0-.1.1-.2.1-.3h0a2.4,2.4,0,0,0-.2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M65.5,103.1h0v-.4c-.1,0-.2.4-.1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M65.5,103.4h.1v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M64,103.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M64,104.4h0c0-.2.1-.3,0-.5v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M64.1,107.3a1.7,1.7,0,0,0-.1-.7c0,.1-.1.4,0,.4h0v.2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M64.5,102.5a1.1,1.1,0,0,0,.1-.8c0,.1-.1.1-.1.2v.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M64.2,104.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M64.2,104.5v.2C64.3,104.7,64.3,104.6,64.2,104.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M64,105.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M64,105.2h0c0-.2.1-.5,0-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M64,103.7h0a2.2,2.2,0,0,0,0-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M64,105.4v.9h.1A2.5,2.5,0,0,0,64,105.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M64.2,106.1h0c0-.2.1-.5,0-.7v.3C64.2,105.8,64.1,105.9,64.2,106.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M65.2,107.1v-.2S65.1,107.1,65.2,107.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M64.4,106.8h-.1a1.3,1.3,0,0,0,.1-.6v-.5a1.3,1.3,0,0,0-.1.6v.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M64.3,107.7h.1v-.5c0-.1.1-.8,0-.8v.8l-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M64,102.5v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M64.5,104.7h0v-.2c-.1-.2.1-.4.1-.6v-.2c0-.1.1-.2.1-.3s-.1-.2-.1-.4a1.6,1.6,0,0,0,.2-1,.4.4,0,0,1-.1.3v.2a.4.4,0,0,0-.1.3v.6c0,.1-.1.2-.1.4h-.1c-.1-.1,0-.4,0-.6v-.2h0c-.1.2,0,.4-.1.6s-.1.7-.1.9Zm0-.9c.2.2,0,.4,0,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M64.4,104.8v.5h0A.4.4,0,0,0,64.4,104.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M64.5,105.2v.4h0C64.5,105.5,64.6,105.3,64.5,105.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M64.6,105.1h0v-.3s-.1.3,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M64.5,105.6v.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M64.5,106v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M64.7,106.4h0v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M49.2,105.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M49.3,105.2v.2h0v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M48.8,105.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M48.7,104.6h0l-.3.2v.2h0c0-.1,0-.2-.1-.2h.1l.5-.6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M52.2,103.7h0v.2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M52.2,104h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M50.7,105.3a.1.1,0,0,1-.1.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M50.5,105.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M49.4,105.8a.4.4,0,0,0-.1-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M49.9,105.3h-.3a.7.7,0,0,0,.6.3s0,.2.1.2,0-.2,0-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M51,102.8h0l.2-.3-.3.3H51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M57.4,96.1l-.2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M51.2,102.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M57.3,96.5c0,.1.1.1.1.2h.1v.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M64.3,90.8h.2c0-.1.1-.2.1-.1h0s.2-.4.3-.2h0v1.1c0,.1.1.2.1.3a4.3,4.3,0,0,1,.1.5v.8c0,.1,0,.3.1.3s0-.2,0-.3,0-.9.1-1.4.1-.3.1-.5v-.5h-.1c0-.1.2,0,.2.1v-.6c0-.1-.1-.2-.1-.4v-.6h0a1.3,1.3,0,0,1-.1-.6l-.2-.2a1.4,1.4,0,0,1-.2-.6h-.2a.8.8,0,0,1-.1.4.3.3,0,0,0-.1.2c.3,0,0,.4,0,.6h.1c.1-.1.1.2.1.3h-.2a.1.1,0,0,1,0,.2c0,.1,0,.1-.1.2v.3a.3.3,0,0,1-.1.2v.6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M102.1,88.9c-.1.2-.2.2-.2.4s0,.3,0,.4h-.1V90h.1c.1.1,0,.3.1.4s-.7.7-1.1.9l-.2.3-.2.2c0,.2.1.5.2.5h.2l.5.3a1.2,1.2,0,0,1,.5.7c.1.5-.7.3-.7.8a.2.2,0,0,0,.2.2c.4.5.4,0,.9,0h.7c.1-.1.6.1.8.1h.2l.3-.2c.2-.2-.1-.6-.4-.6h0c.2-.1.2-.2.2-.4s-.6-.1-.6-.3.4-.4.6-.4.3,0,.3.1h.2c-.1,0,0-.2,0-.2h.2v-.4c-.7-1.1-1.6-2.2-2.4-3.3S102.2,88.8,102.1,88.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M50.8,102.8h-.1A.1.1,0,0,0,50.8,102.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M50.1,103.4l-.2.2h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M50.3,103.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M49.3,104.2h.1a.1.1,0,0,0-.1-.1h0l-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M51.6,104.5h-.2c-.2.1-.2.2-.3.4l-.2.4v.2h.1a.4.4,0,0,1,.1-.3l.4-.6h0c.1,0,.5-.2.4-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M50.1,104.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M65.9,104.4c0,.1-.1.2-.1.3h0A.4.4,0,0,0,65.9,104.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M66.3,103.4v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M66,103.8s-.1.3,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M62.7,103.5s-.1.1,0,.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M62.2,105.8h0l.3.3C62.6,105.9,62.3,105.8,62.2,105.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M65.7,104.1a.2.2,0,0,0,0-.3s-.1.3,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M65.6,105.6h0c0-.1,0-.2.1-.2S65.6,105.6,65.6,105.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M65.7,105.3c.1-.2.2-.4.1-.5s-.1.3-.1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M65.6,104.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M62.1,105.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M50.8,104.1h.3c.1,0,.1.2.2.2h0c-.1.1-.2.3.1.3l.2-.2h0c.1,0,.3-.1.3-.2h-.1c-.1.1-.5.3-.5.4h0l.3-.4h-.2v.2l-.2-.2h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M50.6,104.5l.2.2c.1.1.2.2.1.3v.2h0c.1,0,.1-.3.1-.3s-.1-.3-.1-.4h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M65.3,106.1a4.3,4.3,0,0,0-.1.5l-.4.5v.2h0C64.9,107.1,65.4,106.2,65.3,106.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M50.5,104.1h-.2c0,.1.2.2.4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M49.6,104.9h.5a.1.1,0,0,1-.1.1h.2c0,.1-.1.4.1.3s0-.1.1-.1v.2s-.1.1,0,.1h0c0-.1.1-.2.1-.3v-.2c-.1-.2-.1-.3-.3-.3l-.5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M61.6,105.3h.1c.1,0,.1,0,.1.1h.1C61.9,105.3,61.7,105.3,61.6,105.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M62.3,105.4v.2C62.3,105.6,62.4,105.5,62.3,105.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M61.7,105.1h-.6a.1.1,0,0,1,.1.1h.3C61.6,105.1,61.7,105.2,61.7,105.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M48.7,105.5h.1c.1-.1.2,0,.3,0h0v-.2h.1l.5-.4h0l-.4.4h0c0-.2,0-.4-.2-.4h0c-.2.1-.6.6-.5.8Zm0-.2.4-.6h0a.5.5,0,0,1-.4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M62.1,96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M65.3,107.4l.2-.2a4.3,4.3,0,0,1,.1-.5l.2-.2v-.3c.1,0,.1-.1.2-.2a.4.4,0,0,1,.1-.3c0-.2.1-.3.1-.4s.1-.2.1-.4v-1.2c-.2.3,0,.3,0,.5a.6.6,0,0,1-.1.4c0,.1-.1.1-.1.2v.3a.3.3,0,0,1-.1.2v.5a.4.4,0,0,0-.1.3l-.3.3v.4l-.3.4h0c.1.1-.3.8-.4.9l-.4.2-.4-.2-.2-.2h.8l.3-.4h-.4c0-.2.2-.2.2-.4v-.3a.4.4,0,0,0,.1-.3,3.6,3.6,0,0,0,.2-1h.1a1.9,1.9,0,0,0,.3-.8h-.1a.4.4,0,0,1-.1.3,4.3,4.3,0,0,0-.1.5H65v.2c-.1.2-.1.4-.2.5v.6a.6.6,0,0,1-.1.4v.2c0,.1,0,.3-.1.3h-.2s0-.2-.1-.2h0c.1,0,0-.2.1-.3h0v-.6h-.1c0,.2.3.9-.1.9h0a.4.4,0,0,1,.1.3H64a.1.1,0,0,1,0,.2.1.1,0,0,1-.1-.1,2.1,2.1,0,0,1-.4-1.1l-.2-.3V106a.4.4,0,0,0-.1-.3c0-.1-.1-.2-.1-.4s-.1-.2-.1-.4a.4.4,0,0,0-.1-.3v-.2h-.1v.9h0s0-.3.1-.3h0c0,.1,0,.7.1.7h0l-.2-.3h0c0,.1.1.3.1.4v.3c.1.3.1.6.2.9l.3.8v.2c.1.1.2.2.2.3H64c0,.1.1.1.2.1l.2.2.4-.2c0-.1.1-.1.1-.2l.2-.2A1.4,1.4,0,0,0,65.3,107.4Zm.9-2.6c.1.1,0,.6-.1.6h0C66.1,105.2,66.2,105,66.2,104.8Zm-.4,1.3a.4.4,0,0,0,.1-.3c.1.2,0,.2,0,.3Zm0,0a1.4,1.4,0,0,0-.2.6h-.1Zm-.5,1.1.2-.3a.4.4,0,0,1-.2.3Zm0,.1h0Zm-2.2-1.2a4.3,4.3,0,0,1-.1-.5,3.2,3.2,0,0,1,.3.9c0,.1.1.3.1.4h-.1C63.2,106.6,63.2,106.3,63.1,106.1Zm.6,1.8h0v-.3l-.2-.3a.4.4,0,0,0-.1-.3h.1v.2C63.5,107.3,63.9,107.8,63.7,107.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M62.5,97.6h-.1C62.4,97.7,62.5,97.7,62.5,97.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M68.4,90.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M74.5,71.2l.3-.2h.4c.2,0,.3-.1.3-.2s.1-.1.3-.3-.1-.4-.1-.6-.1-.1-.2,0h-.3a.1.1,0,0,0-.1-.1l-.6-.2c-.1-.1-.3,0-.3.2s.2.2.1.4-.1.3-.1.4.4,0,.3.2-.3.1-.3.3S74.2,71.2,74.5,71.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M74.5,94.2H74c-.1.2-.3,0-.4-.1h0l.2.2h.6v-.2h.1c0,.1,0,.2.1.2h0c-.1-.1-.1-.1-.1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M63.9,100.9c0-.1.1-.3,0-.4v.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M68.6,88.6v.2h.1l.3-.4h0c.1-.1.1-.3.3-.3h-.1a.4.4,0,0,0-.1.3.5.5,0,0,0-.2.4h.1l.3-.5v-.4h0c0,.2-.1.3-.1.5V89h0a1.3,1.3,0,0,0,.2-.9c0-.1.1-.2,0-.3h-.7a.1.1,0,0,1-.1.1c-.2.2-.2.7-.3.9s-.1.2-.1.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M74.7,94h0c-.1,0-.1.3,0,.3h0C74.8,94.3,74.8,94.2,74.7,94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M77.7,86.5c.1-.3,0-.7-.2-.4s-.3.3-.4,0a1.2,1.2,0,0,0-.4-.4l-.7-.3c-.3-.2-.6-.3-.8.1s-.2.9.2.7.8-.2,1,.3.8.4,1.1.4S77.6,86.8,77.7,86.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M82.1,83.8c.3-.4.3-.6.8-.6s.6-.5.7-.9-.1-.3-.1-.3a4.8,4.8,0,0,1-1.1.6.7.7,0,0,0-.7.7c-.1.4-.5.4-.3.8S81.9,84.2,82.1,83.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M74.9,94.2c0-.1,0-.1-.1-.2v.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M60.9,98.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M78.9,87.2l-.2-.4s-.5-.4-.5.1-.6,0-.8.5.1.7.2,1.3.9.1,1.1-.3A1.9,1.9,0,0,0,78.9,87.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M61.9,99.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M61,99.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M62,99.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M62,98.8h-.1C61.9,98.9,62,98.8,62,98.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M59.2,98.9h-.1A.1.1,0,0,0,59.2,98.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M62.8,98.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "63 98.7 62.9 98.7 62.9 98.7 63 98.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M62.9,98.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M59.1,98.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M60.2,99.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M63.2,104.8c0-.3.2-.7,0-.9h0v.3h-.1c0,.2.1.3.1.5v.4a.4.4,0,0,0,.1.3v.3c0,.1.1.2.1.3h0c0-.2-.1-.3,0-.5h0l.3,1.5s-.1.2,0,.2h0c0-.1,0-.3.1-.3h0v.4c0,.2.1.3.1.4h0v-.7a1,1,0,0,0-.1-.3h0c-.2-.2-.1-.4-.2-.6a4.3,4.3,0,0,0-.1-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M63.7,105.4c.1.1.1.5.1.7h.1c0,.1,0,.1.1.2h0a.4.4,0,0,1-.1-.3c0-.1.1-.2,0-.4v-.5h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M85.2,86.4a1.7,1.7,0,0,1-1.4-.1L82.3,86c-.9-.2-1.4-.4-1.7,0s-.3.3-.9.2-.5.5-.2.7.6.5.3.9l-.7.7c-.1.3-.1,0-.3.7s0,1,.2,1,.2-.5.4-.9.7-.9.9-1.4-.1-.7.3-1a1.4,1.4,0,0,1,1.4-.3c.5.1.5.5,1.1.5h1c.2-.1.1-.2.6-.2s.4-.1.9.1a1.7,1.7,0,0,0,1.2.1c.4-.1.6-.1.6-.5H86.1C85.7,86.6,86,86.2,85.2,86.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M63.3,102.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M63.5,101.6c-.1.1-.1.3-.2.4S63.6,101.7,63.5,101.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M63.6,105.2h.1a.1.1,0,0,0-.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M63.6,104.4c0,.1.2.3.2.5h0a1.3,1.3,0,0,0-.1-.6h.1v.2h.1v-.2c-.4-.1-.1-.4-.1-.5s-.1-.2-.1-.3.1-.3.1-.5-.2.3-.2.5h0c.1,0,.1.1.1.2a.4.4,0,0,1-.1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M63.8,101.7h0a.6.6,0,0,0,.1-.4c0-.1-.1-.2-.1-.3h-.1C63.7,101,63.7,101.7,63.8,101.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M63.9,102.9l-.2-.4h0c-.1.1.1.3.1.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M63.8,100.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M63.8,102.4c-.1-.2,0-.1,0-.2h0V102c0,.1-.1.3-.2.3h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M63.1,102.6c.1,0,.2-.3.2-.4s-.2.2-.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M63.7,102.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M63.6,101.3l-.2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M99.4,108.7h.1C99.4,108.6,99.4,108.6,99.4,108.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M64.9,107.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M95.5,107.8a.1.1,0,0,0-.1.1h0c0-.2-.2-.4-.1-.6v-.2l-.3-.2h.2c0-.2-.3-1-.5-1v-.3a.2.2,0,0,0,.1-.3h-.4a.5.5,0,0,1-.2-.4l-.3-.2-.4-.2c0-.1-.1-.3,0-.4s.4-.5.8-.5h.1a6.2,6.2,0,0,1-.1-1.3h0c.3.1.3.3.4-.1a.6.6,0,0,1,.1-.4s0-.2-.1-.2h0l.5-.2a.1.1,0,0,1,.1-.1h-.4c0-.1.1-.4.2-.4h.4c0-.1-.1-.1-.1-.2s.4-.5.5-.5h.5c-.1-.1-.2-.2-.2-.3h.1c.5.2.4-.1.7-.3l.4-.2.7.4c.2.1.4.7.6.7h-.1c-.2.3.1.4.3.6v.2c.4.1.2.2.3.6l.2.4c.1.5-.3.7.2,1h.3v.5c0,.2-.1.2,0,.4a.8.8,0,0,0,.2.4v.3c0,.2.2.5.4.5h.3l.2.2a.1.1,0,0,1,.1-.1h0a.9.9,0,0,1,.3.6l-.5.2a.5.5,0,0,0-.4.2,1.4,1.4,0,0,0-.2.7v.6l-.3.9c0,.2-.1.3-.1.4v.3h13.9a63.2,63.2,0,0,0-6.9-13.9.1.1,0,0,1-.1.1h0l-.2-.3c-.1-.2-.1-.7-.4-.6s-.2.4-.1.6l.3.3a4.3,4.3,0,0,1-.1.5c0,.4.2.9,0,1.3l-.4.5a.4.4,0,0,0-.1.3l-.3.2c0,.2-.1.3-.2.5H105v.2c0,.2-.1.4-.1.6h.4c.1,0,.6-.8.6-.8h.1c.1.2.4-.2.4-.2h.1l-.3.5a7.7,7.7,0,0,0-.2,1.5s0,.2-.1.2,0,.5,0,.7l-.3.2v.3l-.2.3c-.1.2,0,.3,0,.5a7.6,7.6,0,0,0-.4,1.1l-.3.5a.8.8,0,0,0-.2.5h0c0,.4.1.3.4.5l.3.2h.2c0,.1.1.4-.1.4l-1-.2-.4-.2c-.1,0-.1.2-.2.3a1.4,1.4,0,0,1-.9.1h-.1c-.1,0-.4-.2-.4-.1h0c.3-.3.2-.4.7-.4s.6-.1.7-.3h0c-.1-.4-.5-.7-.7-1a2.9,2.9,0,0,1-.3-1h-.1l-.4-.3c-.1-.2-.4-.4-.4-.7h-.4c-.1-.2-.1-.4-.2-.5l-.6-.9v-.7c-.2-.1-.5-.3-.4-.6h0a1.5,1.5,0,0,1-.6-.5c-.1-.4.2-.7.1-1.1l-.3-.4c-.1-.3,0-.6-.1-.9s-.1-.3-.2-.4a2.4,2.4,0,0,1-.2-.9c0-.1.1-.1.1-.2v-.3l.2-.3a1.5,1.5,0,0,0-.3-.7h-.6l-1.3-.6h.1a1.5,1.5,0,0,1,.5-.6h.5c.1-.1.3-.4.5-.3s.3.1.5-.1A.6.6,0,0,0,99,91c0-.2.2-.8.4-.8s.1-.3.1-.5h-.1l.3-.2h.4a1.3,1.3,0,0,0,.1-.6.8.8,0,0,0,.2-.5l.5-.6.2-.3h.2c-8-9.9-20.6-20.9-39.9-27.7,0,0,9.5,9.6,3.5,24.7h.2c.3,0,.2,0,.2.2v.2a.2.2,0,0,0,.2.2h0c0,.2.1.3.1.4s-.1.2-.1.3h0c0,.1,0,.2.1.2a.4.4,0,0,0,.1-.3h.1c0,.1-.1.2-.1.3h-.2c0,.1.1.2.3.2H66c-.1,0-.1.1-.1.2s.1.4.2.7-.1.3-.1.4-.2.4-.1.5h.2l.3.2.4.2.3.2H65.9c.3.2.1.5,0,.7h0v.4c-.1,0-.1.1-.1.2v.6a.1.1,0,0,1-.1.1h-.1a.4.4,0,0,1,.1.3v.5c0,.2-.1.3-.1.5s.1.4.1.6v.8h0c-.1.1-.1.2-.1.4s.1.4.5.4h.2c.2.3.7.3.9.5h-.7c-.2-.1-.4-.3-.6-.2s-.3.6-.4.8l-.3.4-.3.2h0s.1-.2,0-.3h-.1c0-.1.1-.1.2-.2s-.2-.2-.3-.2.1-.3.1-.4.4-.2.3-.6-.3-.2-.4-.4l-.2-.3c-.1-.1-.1-.3-.2-.4s-.1-.1-.1-.2v-.2c-.1-.1-.1-.2-.1-.4l-.3-.2c-.2-.4,0-.6-.4-.8h-.1a.9.9,0,0,0-.1-.5v-.2h-.1V90c.1-.1.1-.3-.1-.3H63a.1.1,0,0,0,.1-.1h0a.5.5,0,0,1-.1-.3h-.2c-.1-.1,0-.2,0-.4v-.2a4.1,4.1,0,0,1-.5.9v.4h0c.4.1-.2.9.5.9H63c.1,0,.2.3.2.4h-.5c-.1.2-.5-.1-.5,0h.1v.3h0l-.4-.2-.5-.3s-.1-.1,0-.1h.9a4.2,4.2,0,0,0-.2-.6h-.4l-.6.8h.8l.3.2h.2s-.1-.1,0-.1h.1c0,.1.1.1.1.3v.3c0,.1.1.2,0,.3h0v.5c-.1,0-.1.1-.1.2s0,.1,0,.1l-.2.3h.1c-.1.2,0,.2,0,.3h0v.2c-.1.1,0,.2-.1.3h-.2c-.2,0-.2.2-.2.3v.2h.2l-.2.4h-.1c-.1,0-.1.3-.2.3a.3.3,0,0,1-.3.3c0,.1,0,.1-.1.1h0c-.1.1.1.1.2.1h.1l.2.2s.3.1.1.3-.5-.3-.6-.3H60v-.2h.2c.1-.1.1-.3.3-.3h0v-.7h0v-.2h-.5c0-.1-.1-.4,0-.4a.9.9,0,0,1-.1-.5h-.2c-.1-.2,0-.4,0-.6s0-.2-.1-.2v-.2h0v-.2h0l-.7.9H59c.2-.1.2.2.2.2s.1.1.1.3.2,0,.2.1h-.1c-.1-.1-.2,0-.3,0l-.2-.2h-.3l-.7.9h.7v.4h.2V97l.2.3c0,.1-.1.2-.1.4h.2a.4.4,0,0,0,.1.3h0c0,.1,0,.5-.1.5s-.3-.1-.5-.1h-.5a.2.2,0,0,0,0,.3h0v.2H58c0,.2.1.2.2.2h0c.1.1.1.4.3.4h.6c.1.2-.1.3,0,.5v1.3c0,.1.1.3.1.4v.4a.5.5,0,0,0-.2.4c0,.1.1.2.1.4s-.1.2-.1.3,0,.3,0,.5-.1.2-.1.4h.9a.6.6,0,0,1-.5.2h-.5v.3c0,.2-.2.2-.2.3s-.2.5-.4.5v-.3c.1-.1.1-.4.1-.5h0a.6.6,0,0,1-.1-.4h0V104h-.1c0-.1.1-.1,0-.2h0c.1-.2.1-.3,0-.4h0c.1-.2.1-.3,0-.4h0v-.2c0-.1,0-.1-.1-.1s-.1-.3-.1-.5v-.2c-.1-.1,0-.2,0-.3V101l-.2-.3a1.1,1.1,0,0,1-.2-.5.3.3,0,0,1,.1-.2H57c0-.1-.1-.3-.1-.4s0-.3,0-.4v-.8h0c-.1-.1-.2-.4,0-.4s0-.1-.1-.1,0-.9.3-.9H57c-.1-.1.1-.4.2-.4h0l-.3.3v.2h-.1c-1.6,1.8-3.5,3.7-5.5,5.6h0a.1.1,0,0,1,.1.1h0l-.2.5-.3.3-.7.5h-.4a.2.2,0,0,1-.2.2h-.1c.1.1.2,0,.3-.1h.6l.2-.2h.3c.1,0,.1,0,.1.1h-.3c.2-.1.5-.1.4-.3l.2-.2h0c.1.1.1.2.3.2h0v.2h0c.1,0,.2-.2.2-.2h.2v.2h0c.1,0,.1-.2.1-.2h0c.2,0,.4.2.6.1H53l-.2-.4c.2-.1.2.2.3.2l.2.3h.2v-.4l-.2-.3h.3c0,.1,0,.2.1.2a1.4,1.4,0,0,1,.2.6h.2a.4.4,0,0,0,.1.3H52.6c-.1.3-.4.2-.2.7s-.2.1-.2.2-.2.2-.2.3l.5.5v.3l.2.3h-.1l-.3-.4h-.3l-.4-.2a2.4,2.4,0,0,0,.8.6s.1.3.2.2h0c-.4,0-.8-.7-1-.7s-.3.2-.4.2h-.4c-.1.1-.1.2-.3.2h-.1l-.8.2h-.3l-.4-.2h-.1l.2.3a.7.7,0,0,1,.1.5h0c-.1,0-.3-.3-.3-.3a2.9,2.9,0,0,0-.7-.8h-.1l.4.8c.1.2.3.4.3.6l-.6-.3c-.1-.1-.1-.4-.3-.4v-.2l-.3-.2h0c.1-.2,0-.3-.1-.5h-.2l.3.5H47a.4.4,0,0,0-.1-.3h-.2a1.8,1.8,0,0,1-.7.5l-2.4,1.9H63.7a.4.4,0,0,1-.2-.5h-.1c-.1-.2-.2-.2-.2-.4h-.1c0-.1-.1-.2-.1-.3a.6.6,0,0,0-.1-.4l-.3-.4a.4.4,0,0,1-.1-.3,1,1,0,0,1-.5-.4l-.2-.3h-.2l-.6-.2h-.3c-.1,0-.1-.1-.1-.2s0-.2.1-.2h.4c.1,0,.2-.1.4.1h.8c.4-.1-.2-.4-.2-.5h.2c0-.1-.1-.3,0-.3a.4.4,0,0,0,.1-.3c0-.1,0-.2-.1-.2v-.2c0-.1.1-.4.2-.4s0-.2.1-.2v-.2h-.2v.2h0c-.1-.1-.1-.3.1-.3h0c.1-.2,0-.3.1-.4v-.2c0-.3.2-.6,0-.8h0l.3-.4c0-.1,0-.4.1-.5h.1c0-.2.1-.2,0-.4h.2s-.1-.1,0-.1.1-.1.1-.4.2-.2.2-.4l.4-.3a4.3,4.3,0,0,1,.1-.5h.2c0-.1,0-.1.1-.1h-.2s0,.2-.1.2h0v-.4a.1.1,0,0,0,.1-.1h-.1c.1-.2-.3-.1-.4-.1h.1c-.1-.1-.3-.2-.4-.1h-.6l-.2-.2h-1V96c.2-.2.7,0,.7-.3h0c.2.1.2,0,.5,0l.4-.2.4.2h0a.1.1,0,0,1,.1.1h.2l.5.2c.1-.1.4-.1.4-.3h.5a.2.2,0,0,1,.2-.2h.3a.1.1,0,0,0,.1.1h0l.4-.2h1.2c.1,0,.3-.1.3.1h-.8l-.4.4h-.8l-.5.3-.2-.2-.4.5v.2a.1.1,0,0,0,0,.2h0v.3a4.3,4.3,0,0,1-.1.5l.3.2v.3l.2.3v.4c.1.3-.1.4-.1.6s.1.3.2.3h.2c0,.1.1.1.1.2a1.3,1.3,0,0,1,.1.6.4.4,0,0,0-.1.3h.2v.4h.2c.1.1.1.2.1.4v.3a4.3,4.3,0,0,0-.1.5h.3v.2c0,.2-.1.3-.1.4s.1.1.1.2a2.2,2.2,0,0,1,.1.8.1.1,0,0,1,.1.1l.3-.3h.2c0-.1.1-.1.2-.1h.9v.2c0,.1-.3.3-.5.3h0c0-.1.1-.3,0-.3h-.1l-.3.2-.5.2h-.5c-.1.1,0,.4,0,.5s-.4.2-.3.6h0c.3.2,0,.3-.1.5s-.1.1-.1.2h-.2l-.3.4h-.1l-.3.3a.4.4,0,0,0-.1.3H95.7C95.7,108.4,95.9,107.8,95.5,107.8Zm11.3-3.8h.2c.3-.3.5-.4.5-.8l.6-.5a.2.2,0,0,0,.2-.2l.8-.6c.2.1.3.4.4.5l.3.3.3.3h.1a.6.6,0,0,0,0,.6v.2c.1.1,0,.4.1.5l.4.3h0c-.1.2-.4,0-.5.1l-.3.5-.2.3a7.5,7.5,0,0,1-.7,1.2c-.1.2-.4.4-.4.8a.1.1,0,0,0,.1.1c0,.1.3.5,0,.6s-.4-.2-.6-.1-.1.4-.5.4h0c.1-.1.1-.1.1-.3h.1c0-.2.1-.3.1-.4h.2s.1-.1,0-.1h-.2a.4.4,0,0,1,.1-.3l-.2-.2-.3-1.3-.2-.3v-.5h0c-.2-.2-.8-.4-.8-.6S106.6,104,106.8,104Zm-56.2-.3Zm-1.7,3.6h0Zm.2-.2c-.2-.1-.3-.3-.4-.4l.4.4Zm2.8.3h-.1c-.1.1.1.3.1.4s0,.2.1.2h-.1l-.4-.4c0,.1,0,.5-.1.5h0a.4.4,0,0,0-.4-.4h.3c.4,0,.4-.3.7-.4s.3.1.4,0h0c.1-.1-.1-.2-.2-.2s-1.6-.1-2.3.1-.1.1-.1.2.6.4.8.5h.1s0,.3.1.3h-.1c-.1,0-.4-.5-.5-.3s.2.3.2.5h0l-.2-.2L50,108h0c-.2-.1-.4-.1-.4-.3h-.1c-.1-.2-.1-.3-.3-.3h0c0-.1.1-.3.2-.3h.2l.5-.2h.7a2.4,2.4,0,0,1,.9-.3c.1,0,.2,0,.2-.1h0c.2,0,.4.3.5.2s.1.4.2.3.2.1.2.1h0C52.6,107.4,52.3,107.2,51.9,107.4Zm12.2-9.3v0Zm-4,.1.3-.4v.3l.2.3h-.2l-.3-.2Zm-.3.2h0c-.2.3-.3-.1-.3-.2a.4.4,0,0,1-.1-.3A1,1,0,0,1,59.8,98.4Zm-.1,3.4c0,.1-.1.2-.1.4s0-.1-.1-.1v-.7a.4.4,0,0,1,.1-.3v-.2c.1,0,.2.2.1.2S59.7,101.5,59.7,101.8Zm2.2,1.1h-.5a.1.1,0,0,0-.1.1c-.2.2,0,.2-.1.4v.3a.1.1,0,0,0,0,.2c0,.1,0,.1-.1.1h-.2c0,.1.2.2.1.3a1.7,1.7,0,0,1-.3.6h-.2c-.3.2-.3.4,0,.7v.2h-.1l-.6-.2h-.2c-.1-.1-.3.1-.4.1h0l.2-.2h.1a.5.5,0,0,0,.2-.4h.1v-.2c0-.1-.1-.2-.1-.3s-.1-.4-.2-.6-.1-.1-.1-.2h.1v-.2c.2-.2,0-.3,0-.3s.1-.5.2-.5h0c-.1-.2.6-.9.9-.9h.6a.1.1,0,0,1,.1.1l.2.2h.2a1.1,1.1,0,0,1-.1.5c0,.1-.1.2,0,.3H62Zm-2.2-2.4a.2.2,0,0,0,.2-.2H60c-.1.1-.1.2-.1.4s-.1,0-.1-.1Zm1,.7h0c-.4.1-.3-.4-.3-.6l.2.2C60.5,100.9,60.5,101.2,60.7,101.2ZM63,99.8h.2S63,99.9,63,99.8Zm-.2-.7h.3v.2h-.1c0,.1-.6.2-.6.2h.3Zm-.1.4h.2v-.2h0c0,.2-.1.2-.3.2h0Zm.5-1.6H64v.2h0c-.1,0-.8.1-.9,0Zm-.3.2c0,.1-.1.1-.1.2s-.3.3-.2.4h.6c0,.1-.1.1-.2.1h-.2l-.3.2h-.4v.3h.2a.9.9,0,0,0,.5.3h0s-.1.1,0,.1.3.4.2.5-.2-.2-.2-.3h-.2c-.1-.1-.1-.1-.1-.2h-.3a.1.1,0,0,0-.1-.1c-.1,0-.3,0-.3.1s0,.1,0,.1h.1a.7.7,0,0,1,.3.6h0c-.1-.2-.5-.7-.7-.7h0c0,.2.1.2.1.3l.2.5a.1.1,0,0,0,.1.1c0,.1,0,.2.1.2l.4.4h.2v.2h-.1l-.5-.3h-.2a.9.9,0,0,1,.1.5h-.1a.3.3,0,0,0-.1-.2v-.6c-.1-.2-.2-.3-.2-.5s-.1-.3-.2-.5a.1.1,0,0,0-.1-.1c-.2-.1,0,.3,0,.4s-.1.1-.1.2h0v-.2c0-.1-.1-.3-.1-.4h0c-.1,0-.1-.1-.2-.2h1a.9.9,0,0,0,.1-.5h-2l-1.1.2h.4l.7.2h.9c-.1,0,0,.8,0,.9l.2.3v.2h-.1V101h0a.4.4,0,0,1-.1-.3l-.2-.2v-.2c.1-.1,0-.3,0-.4s-.2-.2-.2,0v.3h0c-.1.2-.1.3-.2.4s-.1.6-.1.9h.1l-.2.2h0v-.6c0-.2.1-.3.1-.6h0c0-.1.1-.2.1-.3h0a.1.1,0,0,1-.2,0l.2-.4h0l-.6-.3h-1a.1.1,0,0,1-.1-.1h0s-.1-.1,0-.1h3.5v.2h.3c0-.1,0-.2.1-.2l.3-.6C62.8,98,63,98,62.9,98.1Zm-.8.1.3-.6h.1c.1,0,0,.3.2.3h-.3v.2c-.1.1-.1.2-.3.2s-.2-.3-.3-.3-.3.3-.5.3h-.4l.2-.3h0l.3.2c0-.1.3-.5.4-.5h.1ZM94.3,85.3c.1,0,.4-.5.4-.5l.2.2h0a1.5,1.5,0,0,0-.3.7.7.7,0,0,0,1,.4h.3a1,1,0,0,0,1.4-.1l.3-.2c.4-.1.7.3,1.1.2l.3-.2h0l.7.3c-.1.3-.5.5-.7.8l-.3,1s-.1.1,0,.1l-.3,1.2c-.1.2-.3.2-.3.3s0-.4,0-.6a.4.4,0,0,0-.1-.3,1.1,1.1,0,0,0,.3-.8c-.1,0-.1-.1-.1,0h-.1c-.3.2-.3.5-.3.9h0c-.1.2-.2.5-.4.6s-.1.1-.1,0h0c.2-.4.4-.7.3-1.1h-.9a2.2,2.2,0,0,0-1.1-.1l-.5.5c-.2.2-.5.4-.5.7h0c-.1-.1-.2-.4-.1-.4s.6-.4.6-.7-.9.7-1.1.7h0c.2-.6.8-1,.8-1.8h0c-.3,0-1.3.4-1.3.1s.5-.5.5-.7-.5-.4-.5-.8S94.1,85.3,94.3,85.3Zm-8.7-5c.3.1.5.2.5-.1s-.1-.5,0-.6a1,1,0,0,0,.5-.4s.2-.5.4-.5.4.1.5-.1.8.2.4.5-.6-.1-.9.2-.2.3-.1.5.1.5-.3.7l-.8.4a.6.6,0,0,1-.8-.1c-.2-.2-.1-.3-.2-.5s-.1-.4-.6-.5-.7,0-.8-.3.1-.4.2-.3a.6.6,0,0,0,.6.3,1,1,0,0,1,.8.4C85.3,80.1,85.3,80.2,85.6,80.3Zm-7.5-7.7c.2-.2.5-.1.8-.1l1.1-.4h.2l.4-.2c0-.3,0-1.3-.2-1.3l.3-.2a3,3,0,0,1,.7,1c.1.2,0,.4.1.6l.9.3H83c0,.1.1.2.2.4s-.5.2-.5.5h-.2l-.3.7c-.1.3.1.5.2.8s-.2.7-.1,1.1.2.2.1.2a.5.5,0,0,0-.2.4c.1,0,.5,0,.5.1h0v.2h.1c.1,0,.1.1.1,0H83v.2h.7c.1.2.4.2.6.2h0c-.1.1-.1.4-.1.4h0c-.5-.1-.5.3-.6.3h-.3c-.4-.5-.5-.1-1-.1h-.6c-.1.5-.3.8-.8.8s.1-.3,0-.4a.8.8,0,0,0-.9-.4l-.4.2c-.2-.1-.9-.3-.9-.5l.7-.4h.7s.1-.1,0-.1h-.2a2.2,2.2,0,0,1,.1-.8l-.4-.8c-.1-.4.2-.5-.1-.9s-.2-.3-.1-.3-.3-.7-1-.8S78,72.6,78.1,72.6Zm-5.3-5.1c0-.3-.2-.5,0-.5h.6a1.7,1.7,0,0,1,1.1.6.2.2,0,0,1,0,.4c-.2.2,0,.2-.1.5s-.1.3.5.3.5.2.7,0a.3.3,0,0,1,.5,0,.8.8,0,0,1,.1.4c0,.2.2.2.1.4s-.3.4-.2.6.5.2.4.4-.1.2-.3.2-.2-.1,0,.2.3.4.1.5h-.4c-.2.1-.4.2-.5.1s-.2,0-.4.1h-.6c-.2,0-.1.1,0,.2s-.1.1,0,.4-.1.3-.1.5-.2.4-.1.4.1.1.1.4.1.2.2.1.3-.1.5-.1.4-.2.5,0,.3.3.5.2.3-.2.4-.1l.6.3h-.1c-.1.1-.1.3.2.4h.6c.3,0,.8.1.5.4s-.2.5-.6.4l-1-.4c-.4-.2-.4-.6-.5-.6l-.4.2c0,.1-.2.1-.3-.1s0,0-.2-.1-.1-.2-.3,0H73.8c-.3-.1-.3.1-.1.2s.1.3.1.6.4.4.4.8,0,.4.1.6.1.2.1.6,0,.5-.1.6-.2.1-.1.4.1.2.2.3.2.3.2.8-.2.4-.2.7a.8.8,0,0,1-.2.6c-.2.1-.1.2-.1.4s-.1.4-.4.3a1.8,1.8,0,0,0-1-.1.5.5,0,0,1-.6-.2c-.1-.1,0-.1.3-.1s.4,0,.6-.4.2-.4.1-.6v-.4c.2-.3.4-.4.2-.6s-.4-.2-.2-.4.4-.2.3-.5a.8.8,0,0,1-.2-.8c.1-.3.2-.2.1-.6s-.2-.4-.2-.7-.4-.5-.6-.6-.2.1-.2.4v1c-.1.3-.1.3-.2.3s.1.2.2.4-.1.1,0,.4,0,.3-.1.5-.2,0,0,.4.1.3,0,.4-.1.5-.4.5-.2-.2-.3-.4-.1-.2-.1-.5.1-.3,0-.6.1-.4,0-.6-.1-.1.1-.4.2.1.1-.3.1-.6-.1-.9.3-.6.1-1.1-.4-.4-.9-.3a1.1,1.1,0,0,1-.8-.1c-.3-.1-.2-.3-.5-.4s-.3-.2-.1-.5.3-.2.6-.3l.3-.4c.3-.4.6,0,.8.2s.3,0,.4-.3,0-.3.3-.3l.5-.3c0-.2,0,0,.3-.4s.2-.6,0-.6-.1.1-.1-.3,0-.5-.4-.4H70.8c-.2-.2-.4-.3-.3-.5s.1-.5.6-.6.5-.2.4.1-.4.1-.5.2,0,.4.3.4.2-.2.6-.1.8,0,.6-.2a.5.5,0,0,1-.4-.5c.1-.3.2-.5.5-.4s.2.2.3,0,.1-.3-.1-.4-.3-.5-.3-.6S72.8,67.7,72.8,67.5Zm-1.8,8c-.2.1-.3,0-.2-.2l.2-.2C71.2,75,71.1,75.5,71,75.5Zm-.7.3c-.2.4-.4,0-.5-.3s.5-.4.5-.4S70.6,75.4,70.3,75.8Zm1.8-8.7c0-.2.4-.2.4-.2v.3a.3.3,0,0,1-.4.2H72a.2.2,0,0,1-.2-.2c-.1-.2.1-.2.2-.1S72.1,67.3,72.1,67.1Zm-.5-.8h.3c.2.2.2.4,0,.5s-.4,0-.5-.2S71.6,66.3,71.6,66.3Zm-1.1.3c.2-.2.4-.3.5-.1s.2.1.2.1a1,1,0,0,1,.1.3c.1.2.1.3-.1.5s-.3.1-.3-.1-.4-.2-.5-.4S70.4,66.7,70.5,66.6Zm-2.6,3.7c.1-.2.4-.2.5-.2s.4,0,.3-.1a.5.5,0,0,1-.1-.3l.6-.8c.3-.2.4-.3.4-1s-.7-.4-.8-.9-.5-.5-.5-.8-.2-.6.1-.8a.7.7,0,0,0,.4-.4h.4c.4,0,.3.2.3.8s-.2.6.1.9.5.1.5.3.5.2.5.5.3-.1.4.2.1.2.3,0,.2,0,.6.3l.6.5c.3.1.4.3.3.3s-.4-.4-.6-.4-.2.1-.4-.2-.2-.3-.2-.2-.2.3-.4.1a.7.7,0,0,0-.4-.3l-.4-.4-.6-.3c-.1-.1-.3-.1-.2.1a.6.6,0,0,0,.6.5c.2-.1.4.1.7.3s.2.4.5.3.3.2.1.2h-.4a1.7,1.7,0,0,0-.6-.6h-.7a4.3,4.3,0,0,0,.1.5c0,.1-.3.3-.1.4s.1.1-.1.2-.4.2-.4.4-.1.1-.2.2.2.2-.1.3-.2.2-.1.4a.7.7,0,0,0,.5.4c.3.1.6-.2.8-.1s.3,0,.6.3a1.1,1.1,0,0,0,.9.3l.5-.2h.2c0,.1,0,.3-.2.3s-.2.1-.2.3-.3.2-.4.2h-.7l-.4.2h-.2c-.1-.1,0-.1.2-.3s.2-.2,0-.3,0,0-.2.2-.2.1-.3.1-.2.2-.4-.1-.3-.4-.4-.2-.1.3-.1.3a1.1,1.1,0,0,0,0,.8c0,.3.1.4,0,.7s-.1.4-.1.7-.3.9-.1,1.1a.9.9,0,0,1,.3.6c0,.2-.2.3-.2.6a.4.4,0,0,0,.4.2c.3.1.6,0,.7.2s.1.2-.1.4-.4,0-.7.1-.2.2-.6.2-.3-.2,0-.4.7-.3.5-.4-.1-.1-.3.1-.2.1-.4.2-.4.2-.3,0v-.2c.1-.2-.4-.2-.4-.3s.1-.3.5-.5.3-.5.1-.3-.4.2-.4-.1.3-.4.3-.8,0-.7.2-.8.2-1.2-.1-1.3a1.4,1.4,0,0,1-.2-.6c0-.1.2-.1.3-.3a.4.4,0,0,0,.1-.5l-.2-.2H68A.2.2,0,0,1,67.9,70.3Zm0,21.2a.4.4,0,0,0-.1-.3.2.2,0,0,0-.2-.2c-.1-.1,0-.2,0-.3v-.2c0-.2.2-.3.3-.5v-.7h.1c.2,0,.4-.2.3-.3h.1a.8.8,0,0,1,.1-.4.3.3,0,0,0,.1-.2h0c.1-.2,0-.3.3-.4h-.3l.4-.3h.8c.2.1.2.3.2.5s.1.3.2.5v.5c.1,0,.3,0,.3-.1H71c.1.1.1.2.3.2h.1c0,.1,0,.1-.1.2H71l-.3.2-.4.2a.4.4,0,0,1-.1.3c0,.2.1.3.1.5s-.2.2-.2.3.1.2.1.3-.2.3-.2.4h.1a.7.7,0,0,0-.1.5h0v.2c0,.1-.1.2-.1.3s-.1.4-.1.6.3-.1.3.1h.2c0,.1.2.1.2.1h.3v.2c.1.1.1.3.2.3H69.5l-.4.2h-.4a.4.4,0,0,0,.1-.3c.2-.1.4-.2.4-.5s-.1-.2-.2-.3-.2-.2-.2-.3h-.1l-.4-.3a.1.1,0,0,1-.1-.1ZM72,98.9c-.5,1.4-1.9.5-1.6-.5l.4-.2Zm7.7,3.1c-.2-.1-.6-.3-.6-.1l-1,1.9-5.3.8a7.5,7.5,0,0,1-3.3-1.4,3.7,3.7,0,0,1-2-1.9c-.3-1,.1-2.1,0-3s-.1-.5-.2-.5l.5-.5c1.4,1.1-.3,2.7,1.2,3.6l.7.3a1.8,1.8,0,0,0,.7-.8h.8l-.4.4c.5.3,1.2,1.4,1.8,1.4s.8-1,1.5-.8v.5l.6.2h0c.1-.6-.4-2.9.2-2.9s.4.2.6.4a1.8,1.8,0,0,1,.6.9c.1.6-.6,2.5.7,1.8l.2-.3a19.7,19.7,0,0,1,2.2-1.4,3.9,3.9,0,0,0,.8-1l2.4,1.4-.3.6-1.4-.6A9.4,9.4,0,0,0,79.7,102ZM72.2,90.8v-.4h.1c.1,0,0-.1.1-.2s.5.2.5.3v.2a.1.1,0,0,1,.1.1c.1.1.3.1.3.3h0c.2.1.2.2.5.2h.4v.3h-.9c-.1.2.2.3.2.4h.1c-.2.1-.1.1-.1.2h-.1v.2h.1a.8.8,0,0,0-.2.4v.2l-.2.3a.6.6,0,0,0-.1.4l.2.3v.2h.2l.3.2h.5a.2.2,0,0,0-.2.2h-.4l-.3.2a.9.9,0,0,1-.6.3h0a.4.4,0,0,1,.1-.3v-.2c.1-.5-.2-.7-.4-.9h-.2v-.5h0v-.3c0-.1.1-.1.1-.2v-.5c.1-.1,0-.2,0-.3V92h-.1a.4.4,0,0,0-.1-.3v-.8Zm2.3,1.7c-.1-.1-.1-.1,0-.2h.1c0,.1.1.1.1.2v.2h0c.1,0,.1,0,.1-.1h0a.1.1,0,0,0,.1.1h0a.4.4,0,0,0-.2.5h.1a.1.1,0,0,1-.1.1h-.4c0-.1.1-.1.1-.2l-.4.2c0,.1.4.3.5.2h0c.1,0,.3-.1.4,0s.2,0,.1.1h0a.1.1,0,0,0-.1-.1c-.4-.2-.7.4-1-.2s0-.3.2-.3h.2c.1,0,.3-.3.2-.4h0Zm.2-1.6h.4v-.2h0a.1.1,0,0,1,.1.1h.1v.3a.6.6,0,0,0,.1.4c0,.1-.1.1,0,.1a.3.3,0,0,0,.1.2h.3c0,.1.1.1.1,0s.1-.1,0-.2h-.1a.1.1,0,0,1-.1-.1c-.1,0-.1-.1-.1-.2h0v-.2c-.1-.3-.2-.3,0-.5s.2.1.2.2H76a.4.4,0,0,1,.1.3h.2v.2h0c0,.1.1.1.1.2l.5.3H77v.2c.1.1.4.6.1.7h-.1c-.2-.1-.1-.1-.2-.3l-.4-.4h-.1v.5s0,.2.1.2,0,.4,0,.6-.1.2-.1.3v.7c0,.1.2.3.2.5h.2a.1.1,0,0,1,.1-.1h.5v.2h-.8a3.3,3.3,0,0,1-.3.6h0V95l-.2-.3-.2-.3c-.2-.1-.3-.4-.4-.6h-.1v-.3c0-.1-.1-.2-.1-.3h0a.1.1,0,0,0,0-.2.3.3,0,0,0,.1-.2v-.4c0-.2-.1-.3-.1-.4v-.2l-.2-.2c-.1-.2-.1-.4-.3-.4h-.3l-.2-.3h.3a.1.1,0,0,1,.1.1h-.1Zm2.8,8c.8.4.9,2,.1,1.7h0A1.5,1.5,0,0,1,77.5,98.9Zm-2.4-4.1-.2-.2h-1c-.1,0-.5-.5-.5-.5s.1-.2.3-.2h1.4a.3.3,0,0,0,.1.2h.1s.1-.1.1,0h-.1c0,.1,0,.2-.1.2h0C75.2,94.6,75.2,94.8,75.1,94.8Zm-.2-3.4h-.2A.2.2,0,0,1,74.9,91.4Zm-1.3,9.2c-.8.2-.6-1.4-.5-1.8h.1C73.6,99,74.8,100.3,73.6,100.6Zm7.5-3.7c.1-.2.4-.9.6-.9a4.3,4.3,0,0,1,.2,1.1l-.6,1c0,.3-.1.6-.1.9h-1c0-.2-.1-.5.1-.4s.2-.4.4-.3a.1.1,0,0,0-.1-.1c-.3-1.1-1.1-2,.2-2.8l-.3,1.5C80.7,96.9,81.1,97.1,81.1,96.9Zm11.3-2c-.4,0-.2.3-.8.3s-.7-.2-1,0-.4.4-.7.3-.2-.2-.5-.5-.6-.3-.4,0a1.5,1.5,0,0,1,.4.9,2.1,2.1,0,0,1,0,1.1c-.2.5-.3.7-.1.9s.4.4.2.7,0,.6.2.6.1.4-.1.6.1.5.1.8.1.4,0,.8a4.3,4.3,0,0,1-.2,1.2.4.4,0,0,0,.2.7c.2,0,.4.1.1.5s-.9.3-1,.6-.2.5-.6.5-.6-.7-1-.2a2.9,2.9,0,0,1-1.1,1.1c-.3.2-.2.3-.2.5s-.1.1-.4.2,0,.3-.4.5-.5.1-.7.3a1.4,1.4,0,0,1-1,.3c-.3,0-.3-.3-.3-.5s.1-.2-.1-.2-.3-.1-.2-.3.3-.3.4-.6.3-.3.8-.5.6-.1.8-.4l.7-.9c.3-.3.1-.3.1-.6s-.1-.3-.4-.1-.4.5-.8.2-.4-.2-.7-.1-.5.1-.9.2-1.1.1-.8-.3.7-.2.9-.6a1.1,1.1,0,0,1,.6-.6c.2,0,.2-.2.3-.6s.6-.5.5-1-.3-.9.1-1,.3-.2.4-.7.5-.9.3-1.1-.1-.2-.7-.1-.6-.1-.8-.4-.6-.3.1-.9a2.1,2.1,0,0,1,1.5-.6,2.5,2.5,0,0,1,1.2.1c.4.1.3.1.5-.5s.4-1,.2-1.1-.5-.4-.7-.3-.1.4-.6.5-.8-.2-1.2.1-.5.1-.9.5-.8.3-.9,0,.2-.4.3-.9.1-.9.5-.9,1,.1,1.3-.4,1-.1,1.4-.1.2.2.8-.3.8-.5.8-1.1-.3-.6-.4-1,.1-.7-.1-.9-.9.1-1.1-.5a1.2,1.2,0,0,1-.2-.5c-.1-.2-.1-.1-.5.3s-.9,0-1.2-.2-.3-.5-.7-.5-.8-.3-1-.3l-1.2-.4c-.4-.1-.8-.2-.9.3s-.3.4-.2.7-.5.8-.8,1a2,2,0,0,0-.5,1.3v.3s.1.9-.3,1.1-.4-.3-.4-.9-.5-.5-.5-1.1-.5-.5-.8-1.1a2.8,2.8,0,0,1-.1-1.2c0-.1-.1-.2-.1-.4s-.2-.3-.4-.1-.5.2-.9-.1-.7-.2-1-.2a.4.4,0,0,1-.4-.3,1.1,1.1,0,0,0,0-.8c-.1-.5-.9,0-1-.2s-1.2-.5-1.6-.5-1.3-.2-1.4-.4.6-.2,1.7,0,.9,0,1.4-.2a3.3,3.3,0,0,1,2.2.1c.3.3,1.4.2,2.2.5s1.8.4,2-.3l.4-.3h.5c.3-.2.3-.4.2-.9a1.5,1.5,0,0,1,.1-.6c0-.2.3-.4.5-.6a1.1,1.1,0,0,0,.2-.4c.2-.3.2-.5.4-.4l.5-.3a.5.5,0,0,1,.6-.1c.7-.1,1-.3,1.3.1a3.2,3.2,0,0,1-.1.7c0,.4.2.8.1,1s-.4.1-.4.4-.1.6-.3.6,0,.2-.3.4-.2.5,0,.4.8-.2,1,.1.7.3,1.3.2.6.1,1,.2.8,0,.8-.4.1-.4.5-.6.3-.7,0-.6-.5,0-.6-.5-.2-.5-.6-1,.6-1,.6-1-.1-.1.2-.6.3-.1.7-.6.6-.6,1.3-.2,1.4.8,1.4,1.3.5,1,.3,1.2-.1.6-.3.9-1,.2-1,.8.5.7.3,1.2-.4.2-.6.8-.2.9.2,1.2.3.2.4.6.1.3.2.8-.2.3.2.9a1.3,1.3,0,0,1,.3,1.3c-.2.5-1,.9-1.2,1.4s.2,1.4.6,1.4.5.3,1,.1,1.2-.4,1.5-.2.1,0,.7,0a.9.9,0,0,1,1.1.7c0,.4,0,.6-.2.6s-.1.1-.3.6-.6.5-.9.2S92.9,94.9,92.4,94.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M87.4,96.6a2.9,2.9,0,0,0-.6,1.7c-.1.7,0,.9-.3,1.4s-.1,1.2-.6,1.6-.7.7-.4.7,1.4,0,1.6-.6.3-.7.7-1a1.9,1.9,0,0,0,.5-1.2c0-.7-.2-1.4.1-1.7s0-.9,0-.9S87.7,96.1,87.4,96.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M63.2,103.9h.1c.1-.1-.1-.5-.1-.7s.1-.2.1-.4a.1.1,0,0,0,.1-.1c-.1.2-.3.3-.3.5v.3h0C63.2,103.4,63.2,103.8,63.2,103.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M68,70.7h.5l.2.2a.4.4,0,0,1-.1.5c-.1.2-.3.2-.3.3a1.4,1.4,0,0,0,.2.6c.3.1.3,1.1.1,1.3s-.2.5-.2.8-.3.5-.3.8.3.3.4.1.2.2-.1.3-.5.3-.5.5.5.1.4.3v.2c-.1.2.2.1.3,0s.2,0,.4-.2.2-.1.3-.1-.1.2-.5.4-.3.4,0,.4.3-.1.6-.2.5.1.7-.1.2-.1.1-.4-.4-.1-.7-.2a.4.4,0,0,1-.4-.2c0-.3.2-.4.2-.6a.9.9,0,0,0-.3-.6c-.2-.2,0-.8.1-1.1s-.1-.4.1-.7,0-.4,0-.7a1.1,1.1,0,0,1,0-.8s.1,0,.1-.3.2-.1.4.2.2.1.4.1.2.1.3-.1.1-.3.2-.2.1.1,0,.3-.3.2-.2.3h.2l.4-.2h.7c.1,0,.4,0,.4-.2s.1-.2.2-.3.2-.2.2-.3h-.2l-.5.2a1.1,1.1,0,0,1-.9-.3c-.3-.3-.4-.2-.6-.3s-.5.2-.8.1a.7.7,0,0,1-.5-.4c-.1-.2-.1-.3.1-.4s0-.2.1-.3.2,0,.2-.2.1-.2.4-.4.2-.2.1-.2.1-.3.1-.4a4.3,4.3,0,0,1-.1-.5h.7a1.7,1.7,0,0,1,.6.6h.4c.2,0,.1-.2-.1-.2s-.3-.1-.5-.3-.5-.4-.7-.3a.6.6,0,0,1-.6-.5c-.1-.2.1-.2.2-.1l.6.3.4.4a.7.7,0,0,1,.4.3c.2.2.3.1.4-.1s.1-.1.2.2.1.1.4.2.4.4.6.4,0-.2-.3-.3l-.6-.5c-.4-.3-.4-.4-.6-.3s-.1.2-.3,0-.3,0-.4-.2-.5-.3-.5-.5-.2-.1-.5-.3-.2-.4-.1-.9.1-.8-.3-.8h-.4a.7.7,0,0,1-.4.4c-.3.2-.1.5-.1.8s.5.3.5.8.8.2.8.9-.1.8-.4,1l-.6.8a.5.5,0,0,0,.1.3c.1.1-.1.1-.3.1s-.4,0-.5.2A.2.2,0,0,0,68,70.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M72.8,68.5c.2.1.3.3.1.4s-.3,0-.3,0-.4.1-.5.4a.5.5,0,0,0,.4.5c.2.2-.2.3-.6.2s-.3.1-.6.1-.4-.3-.3-.4.5.1.5-.2.1-.3-.4-.1-.5.3-.6.6.1.3.3.5h1.3c.4-.1.4.1.4.4s0,.3.1.3.3.3,0,.6-.3.2-.3.4l-.5.3c-.3,0-.2,0-.3.3s-.3.4-.4.3-.5-.6-.8-.2l-.3.4c-.3.1-.4-.1-.6.3s-.2.5.1.5.2.3.5.4a1.1,1.1,0,0,0,.8.1c.5-.1.6-.1.9.3s-.2.8-.1,1.1,0,.4.1.9.1.1-.1.3-.2.3-.1.4-.1.3,0,.6,0,.3,0,.6-.1.3.1.5.1.4.3.4.4-.3.4-.5.2-.1,0-.4-.1-.3,0-.4.2-.3.1-.5.1-.3,0-.4-.3-.3-.2-.4.1,0,.2-.3v-1c0-.3,0-.4.2-.4s.7.2.6.6.1.3.2.7,0,.3-.1.6a.8.8,0,0,0,.2.8c.1.3-.1.3-.3.5s0,.2.2.4,0,.3-.2.6V80c.1.2.1.3-.1.6s-.4.5-.6.4-.4,0-.3.1a.5.5,0,0,0,.6.2,1.8,1.8,0,0,1,1,.1c.3.1.5-.1.4-.3s-.1-.3.1-.4a.8.8,0,0,0,.2-.6c0-.3.1-.2.2-.7s0-.7-.2-.8-.2-.1-.2-.3.1-.2.1-.4.1-.3.1-.6.1-.4-.1-.6-.1-.2-.1-.6-.3-.6-.4-.8,0-.5-.1-.6-.2-.3.1-.2h1.1c.2-.2.2-.1.3,0s.2-.1.2.1.3.2.3.1l.4-.2c.1,0,.1.4.5.6l1,.4c.4.1.3-.1.6-.4s-.2-.4-.5-.4h-.6c-.3-.1-.3-.3-.2-.4H77l-.6-.3c-.1-.1-.3.1-.4.1s-.3-.1-.5-.2-.3-.1-.5,0-.3-.1-.5.1-.2.1-.2-.1,0-.3-.1-.4.1-.2.1-.4.2-.2.1-.5.1-.3,0-.4-.2-.2,0-.2H75c.2-.1.3-.2.4-.1s.3,0,.5-.1h.4c.2-.1.1-.2-.1-.5s-.1-.2,0-.2.2-.1.3-.2-.2-.2-.4-.4.1-.3.2-.6-.1-.2-.1-.4a.8.8,0,0,0-.1-.4.3.3,0,0,0-.5,0c-.2.2-.2.1-.7,0s-.6,0-.5-.3-.1-.3.1-.5a.2.2,0,0,0,0-.4,1.7,1.7,0,0,0-1.1-.6h-.6c-.2,0,0,.2,0,.5s-.3.3-.3.4S72.6,68.4,72.8,68.5Zm1.4,2.6c0-.2.3-.2.3-.3s-.3-.2-.3-.2.1-.2.1-.4,0-.2-.1-.4.2-.3.3-.2l.6.2a.1.1,0,0,1,.1.1h.3c.1-.1.2-.2.2,0s.2.4.1.6-.4.2-.3.3-.1.2-.3.2h-.4l-.3.2C74.2,71.2,74.1,71.2,74.2,71.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M71.9,66.9c.2-.1.2-.3,0-.5h-.3s-.4.2-.2.4S71.8,66.9,71.9,66.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M71.8,67.2a.2.2,0,0,0,.2.2h.2a.3.3,0,0,0,.4-.2v-.3s-.4,0-.4.2,0,0-.1,0S71.7,67,71.8,67.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M70.9,67.3c0,.2.1.2.3.1s.2-.3.1-.5a1,1,0,0,0-.1-.3s-.1.1-.2-.1-.3-.1-.5.1-.2.1-.1.3S70.8,67.2,70.9,67.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M69.8,75.5c.1.3.3.7.5.3s.3-.8,0-.7S69.7,75.2,69.8,75.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M70.8,75.3c-.1.2,0,.3.2.2s.2-.5,0-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M94.2,95.5c.2-.5.1-.5.3-.6s.2-.2.2-.6a.9.9,0,0,0-1.1-.7c-.6,0-.3.3-.7,0s-1,0-1.5.2-.5-.2-1-.1-.8-1-.6-1.4,1-.9,1.2-1.4a1.3,1.3,0,0,0-.3-1.3c-.4-.6,0-.5-.2-.9s-.1-.4-.2-.8-.1-.4-.4-.6-.3-.6-.2-1.2.3-.3.6-.8-.3-.6-.3-1.2.8-.6,1-.8,0-.7.3-.9-.3-.8-.3-1.2-.7-.8-1.4-1.3-1-.2-1.3.2-.5.1-.7.6-.2.6-.2.6-.9.5-.6,1,.6.5.6,1,.2.5.6.5.4.4,0,.6-.5.1-.5.6-.3.4-.8.4-.5-.3-1-.2-1,.1-1.3-.2-.3-.2-1-.1-.3-.2,0-.4.2-.3.3-.4.3-.2.3-.6.3-.1.4-.4-.1-.6-.1-1a3.2,3.2,0,0,0,.1-.7c-.3-.4-.6-.2-1.3-.1a.5.5,0,0,0-.6.1l-.5.3c-.2-.1-.2.1-.4.4a1.1,1.1,0,0,1-.2.4c-.2.2-.5.4-.5.6a1.5,1.5,0,0,0-.1.6c.1.5.1.7-.2.9h-.5l-.4.3c-.2.7-1.1.6-2,.3s-1.9-.2-2.2-.5a3.3,3.3,0,0,0-2.2-.1c-.5.2-.3.5-1.4.2s-1.9-.2-1.7,0,.9.4,1.4.4,1.6.2,1.6.5.9-.3,1,.2a1.1,1.1,0,0,1,0,.8.4.4,0,0,0,.4.3c.3,0,.7-.1,1,.2s.7.3.9.1.4.1.4.1.1.3.1.4a2.8,2.8,0,0,0,.1,1.2c.3.6.8.4.8,1.1s.5.5.5,1.1.1,1.2.4.9.3-1.1.3-1.1v-.3a2,2,0,0,1,.5-1.3c.3-.2.8-.7.8-1s0-.2.2-.7.5-.4.9-.3l1.2.4c.2,0,.6.4,1,.3s.4.2.7.5.7.6,1.2.2.4-.5.5-.3a1.2,1.2,0,0,0,.2.5c.2.6.8.3,1.1.5s-.1.5.1.9.3.4.4,1-.1.6-.8,1.1-.4.3-.8.3-1.2-.5-1.4.1-1,.3-1.3.4-.5.5-.5.9-.3.6-.3.9.5.3.9,0,.4-.1.9-.5.7-.1,1.2-.1.4-.5.6-.5.5.1.7.3,0,.5-.2,1.1-.1.6-.5.5a2.5,2.5,0,0,0-1.2-.1,2.1,2.1,0,0,0-1.5.6c-.7.6-.3.6-.1.9s.1.5.8.4.5-.1.7.1-.3.5-.3,1.1,0,.6-.4.7-.1.5-.1,1-.4.6-.5,1-.1.6-.3.6a1.1,1.1,0,0,0-.6.6c-.2.4-.6.1-.9.6s.4.4.8.3.5,0,.9-.2.4-.2.7.1.5,0,.8-.2.3-.2.4.1.2.3-.1.6l-.7.9c-.2.3-.3.2-.8.4s-.7.3-.8.5-.3.3-.4.6,0,.4.2.3.2.1.1.2,0,.5.3.5a1.4,1.4,0,0,0,1-.3c.2-.2.2-.2.7-.3s.2-.4.4-.5.3,0,.4-.2-.1-.3.2-.5a2.9,2.9,0,0,0,1.1-1.1c.4-.5.6.1,1,.2s.5-.2.6-.5.7-.2,1-.6.1-.5-.1-.5a.4.4,0,0,1-.2-.7,4.3,4.3,0,0,0,.2-1.2c.1-.4,0-.4,0-.8s-.3-.6-.1-.8.3-.5.1-.6-.4-.2-.2-.6,0-.4-.2-.7-.1-.4.1-.9a2.1,2.1,0,0,0,0-1.1A1.5,1.5,0,0,0,89,95c-.2-.3,0-.3.4,0s.2.4.5.5.4-.1.7-.3.5.1,1,0,.4-.3.8-.3.6.4.9.8S94.1,96,94.2,95.5ZM81.7,83.3a.7.7,0,0,1,.7-.7,4.8,4.8,0,0,0,1.1-.6s.1-.1.1.3-.2.8-.7.9-.5.2-.8.6-.4.6-.7.3S81.6,83.7,81.7,83.3Zm-5.3,3.2c-.2-.5-.6-.4-1-.3s-.4-.2-.2-.7.5-.3.8-.1l.7.3a1.2,1.2,0,0,1,.4.4c.1.3.1.2.4,0s.3.1.2.4,0,.4-.2.4S76.7,87,76.4,86.5Zm1.2,2.2c-.1-.6-.4-.9-.2-1.3s.7,0,.8-.5.5-.1.5-.1l.2.4a1.9,1.9,0,0,1-.2,1.2C78.5,88.8,77.7,89.3,77.6,88.7Zm9.2-1.5a1.7,1.7,0,0,1-1.2-.1c-.5-.2-.5,0-.9-.1s-.4.1-.6.2h-1c-.6,0-.6-.4-1.1-.5a1.4,1.4,0,0,0-1.4.3c-.4.3-.1.5-.3,1s-.7,1-.9,1.4-.2.8-.4.9-.4-.2-.2-1,.2-.4.3-.7l.7-.7c.3-.4,0-.7-.3-.9s-.4-.7.2-.7.5.1.9-.2.8-.2,1.7,0l1.5.3a1.7,1.7,0,0,0,1.4.1c.8-.2.5.2.9.2h1.3C87.4,87.1,87.2,87.1,86.8,87.2Zm1.6,10.3c-.3.3-.1,1-.1,1.7a1.9,1.9,0,0,1-.5,1.2c-.4.3-.4.5-.7,1s-1.3.7-1.6.6-.1-.4.4-.7.3-1.1.6-1.6.2-.7.3-1.4a2.9,2.9,0,0,1,.6-1.7c.3-.5.9-.1,1,0S88.6,97.2,88.4,97.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M83.6,79.2c-.1-.1-.3-.1-.2.3s.2.3.8.3.4.2.6.5,0,.3.2.5a.6.6,0,0,0,.8.1l.8-.4c.4-.2.5-.4.3-.7s-.2-.2.1-.5.6,0,.9-.2-.2-.7-.4-.5-.4.1-.5.1-.4.5-.4.5a1,1,0,0,1-.5.4c-.1.1,0,.2,0,.6s-.2.2-.5.1-.3-.2-.6-.4a1,1,0,0,0-.8-.4A.6.6,0,0,1,83.6,79.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M78.4,72.9c.7.1,1.6-.4,1,.8s.1.2.1.3,0,.5.1.9l.4.8a2.2,2.2,0,0,0-.1.8h.2c.1,0,0,.1,0,.1h-.7l-.7.4c0,.2.7.4.9.5l.4-.2a.8.8,0,0,1,.9.4c.1.1,0,.3,0,.4s.7-.3.8-.8h.6c.5,0,.6-.4,1,.1h.3c.1,0,.1-.4.6-.3h0s0-.3.1-.4h0c-.2,0-.5,0-.6-.2H83v-.2h-.1c0,.1,0,0-.1,0h-.1v-.2h0c0-.1-.4-.1-.5-.1a.5.5,0,0,1,.2-.4c.1,0,0-.2-.1-.2s.1-.7.1-1.1-.3-.5-.2-.8l.3-.7h.2c0-.3.4-.4.5-.5s-.2-.3-.2-.4h-.6l-.9-.3c-.1-.2,0-.4-.1-.6a3,3,0,0,0-.7-1l-.3.2c.2,0,.2,1,.2,1.3l-.4.2H80l-1.1.4c-.3,0-.6-.1-.8.1S78.3,72.9,78.4,72.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M94,85.6c0,.2-.4.6-.5.7s1-.1,1.3-.1h0c0,.8-.6,1.2-.8,1.8h0c.2,0,.7-.6,1.1-.7s-.5.5-.6.7,0,.3.1.4h0c0-.3.3-.5.5-.7l.5-.5a2.2,2.2,0,0,1,1.1.1h.9c.1.4-.1.7-.3,1.1h0c0,.1,0,0,.1,0s.3-.4.4-.6h0c0-.4,0-.7.3-.9h.1c0-.1,0,0,.1,0a1.1,1.1,0,0,1-.3.8.4.4,0,0,1,.1.3c0,.2-.3.4,0,.6s.2-.1.3-.3l.3-1.2c-.1,0,0-.1,0-.1l.3-1c.2-.3.6-.5.7-.8l-.7-.3h0l-.3.2c-.4.1-.7-.3-1.1-.2l-.3.2a1,1,0,0,1-1.4.1h-.3a.7.7,0,0,1-1-.4,1.5,1.5,0,0,1,.3-.7h0l-.2-.2s-.3.5-.4.5-.5-.5-.8-.5S93.6,85.3,94,85.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M51.2,102.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M51.2,102.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M47.6,106.1h0l.3.2v.2c.2,0,.2.3.3.4l.6.3c0-.2-.2-.4-.3-.6l-.4-.8h.1a2.9,2.9,0,0,1,.7.8s.2.3.3.3h0a.7.7,0,0,0-.1-.5l-.2-.3H49l.4.2h.3l.8-.2h.1c.2,0,.2-.1.3-.2h.4c.1,0,.2-.2.4-.2s.6.7,1,.7h0c-.1.1-.2-.2-.2-.2a2.4,2.4,0,0,1-.8-.6l.4.2h.3l.3.4h.1l-.2-.3v-.3l-.5-.5c0-.1.1-.2.2-.3s0-.2.2-.2.1-.4.2-.7h1.6a.4.4,0,0,1-.1-.3h-.2a1.4,1.4,0,0,0-.2-.6c-.1,0-.1-.1-.1-.2h-.3l.2.3v.4h-.2l-.2-.3c-.1,0-.1-.3-.3-.2l.2.4h-.4c-.2.1-.4-.1-.6-.1h0s0,.2-.1.2h0v-.2h-.2s-.1.2-.2.2h0v-.2h0c-.2,0-.2-.1-.3-.2h0l-.2.2c.1.2-.2.2-.4.3H51c0-.1,0-.1-.1-.1h-.3l-.2.2h-.6c-.1.1-.2.2-.3.1h.1a.2.2,0,0,0,.2-.2h.4l.7-.5.3-.3.2-.5h0a.1.1,0,0,0-.1-.1h-.1l-.2.3h-.2a.1.1,0,0,1-.1.1l-.4.3h-.4l-.6.5h0a.1.1,0,0,1,.1.1h-.3l-.4.3h.1l-.5.6h-.2l-.6.5C47.6,105.8,47.7,105.9,47.6,106.1Zm4.6-2.5h-.1Zm-.2.4Zm-2.9,1.8h0Zm.1,0Zm.1-.4h0v-.2h0v.2Zm.1.4v-.3A.4.4,0,0,1,49.4,105.8Zm.9-.1c-.1,0-.1-.2-.1-.2a.7.7,0,0,1-.6-.3h.3l.4.2S50.4,105.7,50.3,105.7Zm.2-.1Zm.1-.1h0a.1.1,0,0,0,.1-.1h-.1Zm.8-.8h0l-.4.6a.4.4,0,0,0-.1.3h-.1v-.2l.2-.4c.1-.2.1-.3.3-.4h.2l.2-.2h0C51.9,104.5,51.5,104.7,51.4,104.7Zm-.6-.8h.4l.2.2v-.2h.2l-.3.4h0c0-.1.4-.3.5-.4h.1c0,.1-.2.2-.3.2h0l-.2.2c-.3,0-.2-.2-.1-.3h0c-.1,0-.1-.2-.2-.2h-.3Zm-.3.2h.2c-.2.1-.4,0-.4-.1Zm.4.4c0,.1.1.3.1.4s0,.3-.1.3h0V105c.1-.1,0-.2-.1-.3l-.2-.2h.3Zm-.8-.1Zm0,.2c.2,0,.2.1.3.3v.2c0,.1-.1.2-.1.3h0c-.1,0,0-.1,0-.1v-.2c-.1,0,0,.1-.1.1s-.1-.2-.1-.3H50a.1.1,0,0,0,.1-.1h-.5Zm-1,0h0c.2,0,.2.2.2.4h0l.4-.4h0l-.5.4h-.1v.2h0c-.1,0-.2-.1-.3,0h-.2C48.5,105.2,48.9,104.7,49.1,104.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M48.3,105.2h0v-.2l.3-.2h0l-.5.4h0C48.3,105,48.3,105.1,48.3,105.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M50.6,103.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M49.1,104.7h0l-.4.6h0A.5.5,0,0,0,49.1,104.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M46.8,106.3h0l-.8.6a1.8,1.8,0,0,0,.7-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M47.2,106.3h.4l-.3-.5c-.1.1-.2.3-.4.4a.4.4,0,0,1,.1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M48.7,106.7c.1.1.2.3.4.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M52.6,106.8c-.1.1-.2-.2-.2-.3s-.3-.2-.5-.2h0c0,.1-.1.1-.2.1a2.4,2.4,0,0,0-.9.3h-.7l-.5.2h-.2c-.1,0-.2.2-.2.3h0c.2,0,.2.1.3.3h.1c0,.2.2.2.4.3h0l.2.3.2.2h0c0-.2-.4-.2-.2-.5s.4.3.5.3h.1c-.1,0-.1-.3-.1-.3h-.1c-.2-.1-.8-.2-.8-.5s.1-.1.1-.2,1.6-.6,2.3-.1.3.1.2.2h0c-.1.1-.2,0-.4,0s-.3.4-.7.4H51a.4.4,0,0,1,.4.4h0c.1,0,.1-.4.1-.5l.4.4H52c-.1,0-.1-.1-.1-.2s-.2-.3-.1-.4h.1c.4-.2.7,0,.9-.5h0S52.6,106.9,52.6,106.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M48.9,107.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M72.2,91.6a.4.4,0,0,1,.1.3h.1v.3c0,.1.1.2,0,.3v.5c0,.1-.1.1-.1.2v.3h0v.5h.2c.2.2.5.4.4.9v.2a.4.4,0,0,0-.1.3h0a.9.9,0,0,0,.6-.3l.3-.2h.4a.2.2,0,0,1,.2-.2h-.5l-.3-.2h-.2v-.2l-.2-.3a.6.6,0,0,1,.1-.4l.2-.3v-.2a.8.8,0,0,1,.2-.4h-.1v-.2h.1c0-.1-.1-.1.1-.2h-.1c0-.1-.3-.2-.2-.4h.9v-.3H74c-.3,0-.3-.1-.5-.2h0c0-.2-.2-.2-.3-.3a.1.1,0,0,0-.1-.1v-.2c0-.1-.4-.3-.5-.3s0,.2-.1.2h-.1v1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M74.8,90.7h0a.1.1,0,0,0-.1-.1h-.3l.2.3h.3c.2,0,.2.2.3.4l.2.2v.2c0,.1.1.2.1.4v.4a.3.3,0,0,1-.1.2.1.1,0,0,1,0,.2h0c0,.1.1.2.1.3v.3h.1c.1.2.2.5.4.6l.2.3.2.3v.6h0a3.3,3.3,0,0,0,.3-.6h.8v-.2h-.5a.1.1,0,0,0-.1.1h-.2c0-.2-.2-.4-.2-.5v-.7c0-.1.1-.2.1-.3s-.1-.4,0-.6-.1-.2-.1-.2v-.5h.1l.4.4c.1.2,0,.2.2.3h.1c.3-.1,0-.6-.1-.7v-.2h-.1l-.5-.3c0-.1-.1-.1-.1-.2h0v-.2h-.2a.4.4,0,0,0-.1-.3h-.1c0-.1-.1-.1-.2-.2s-.1.2,0,.5v.2h0c0,.1,0,.2.1.2a.1.1,0,0,0,.1.1H76c.1.1.1.2,0,.2s-.1.1-.1,0h-.3a.3.3,0,0,1-.1-.2c-.1,0,0,0,0-.1a.6.6,0,0,1-.1-.4v-.3h-.1a.1.1,0,0,0-.1-.1h0v.2h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M74.6,91.2h.3a.2.2,0,0,0-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M74.4,92.6h.1c.1.1-.1.4-.2.4h-.2c-.2,0-.3.2-.2.3s.6,0,1,.2a.1.1,0,0,1,.1.1h0c.1-.1-.1-.1-.1-.1s-.3,0-.4,0h0c-.1.1-.5-.1-.5-.2l.4-.2c0,.1-.1.1-.1.2h.4a.1.1,0,0,0,.1-.1h-.1a.4.4,0,0,1,.2-.5h0a.1.1,0,0,1-.1-.1h0c0,.1,0,.1-.1.1h0v-.2c0-.1-.1-.1-.1-.2h-.1c-.1.1-.1.1,0,.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M75.2,94.5c.1,0,.1-.1.1-.2h.1c0-.1-.1,0-.1,0h-.1a.3.3,0,0,1-.1-.2H73.7c-.2,0-.2.1-.3.2s.4.5.5.5h1l.2.2c.1,0,.1-.2.1-.3Zm-.6,0h0c-.1,0-.1-.1-.1-.2h-.1v.2h-.6l-.2-.2h0c.1.1.3.3.4.1h.5c0,.1,0,.1.1.2Zm.1-.1c-.1,0-.1-.3,0-.3h0c.1.2.1.3,0,.4Zm.3-.1h-.1V94c.1.1.1.1.1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M107.3,104.8h0v.5l.2.3.3,1.3.2.2a.4.4,0,0,0-.1.3h.2c.1,0,0,.1,0,.1h-.2c0,.1-.1.2-.1.4h-.1c0,.2,0,.2-.1.3h0c.4,0,.3-.3.5-.4s.5.1.6.1,0-.5,0-.6a.1.1,0,0,1-.1-.1c0-.4.3-.6.4-.8a7.5,7.5,0,0,0,.7-1.2l.2-.3.3-.5c.1-.1.4.1.5-.1h0l-.4-.3c-.1-.1,0-.4-.1-.5v-.2a.6.6,0,0,1,0-.6h-.1l-.3-.3-.3-.3c-.1-.1-.2-.4-.4-.5l-.8.6a.2.2,0,0,1-.2.2l-.6.5c0,.4-.2.5-.5.8h-.2c-.2,0-.4,0-.3.2S107.1,104.6,107.3,104.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M62.8,89.2H63a.5.5,0,0,0,.1.3h0a.1.1,0,0,1-.1.1h-.1c.2,0,.2.2.1.3v.3h.1v.2a.9.9,0,0,1,.1.5h.1c.4.2.2.4.4.8l.3.2c0,.2,0,.3.1.4v.2c0,.1,0,.2.1.2s.1.3.2.4l.2.3c.1.2.4.2.4.4s0,.4-.3.6-.1.3-.1.4.3.1.3.2-.2.1-.2.2H65c.1.1,0,.3,0,.3h0l.3-.2.3-.4c.1-.2.2-.7.4-.8s.4.1.6.2h.7c-.2-.2-.7-.2-.9-.5h-.2c-.4,0-.4-.1-.5-.4s0-.3.1-.4h0v-.8c0-.2-.1-.4-.1-.6s.1-.3.1-.5V91a.4.4,0,0,0-.1-.3h.1a.1.1,0,0,0,.1-.1V90c0-.1,0-.2.1-.2v-.4h0c.1-.2.3-.5,0-.7h1.2l-.3-.2-.4-.2-.3-.2h-.2c-.1-.1,0-.4.1-.5s.1-.3.1-.4-.3-.4-.2-.7,0-.2.1-.2h-.1c-.2,0-.3-.1-.3-.2h.2c0-.1.1-.2.1-.3h-.1a.4.4,0,0,1-.1.3c-.1,0-.1-.1-.1-.2h0c0-.1.1-.2.1-.3s-.1-.2-.1-.4h0a.2.2,0,0,1-.2-.2v-.2c0-.2.1-.2-.2-.2h-.2a36.1,36.1,0,0,1-2.2,4.4v.2C62.8,89,62.7,89.1,62.8,89.2Zm1.6,1.4V90a.3.3,0,0,0,.1-.2v-.3c.1-.1.1-.1.1-.2a.1.1,0,0,0,0-.2h.2c0-.1,0-.4-.1-.3h-.1c0-.2.3-.6,0-.6a.3.3,0,0,1,.1-.2.8.8,0,0,0,.1-.4H65a1.4,1.4,0,0,0,.2.6l.2.2a1.3,1.3,0,0,0,.1.6h0v.6c0,.2.1.3.1.4v.6c0-.1-.2-.2-.2-.1h.1v.5c0,.2-.1.3-.1.5s0,.9-.1,1.4.1.3,0,.3-.1-.2-.1-.3v-.8a4.3,4.3,0,0,0-.1-.5c0-.1-.1-.2-.1-.3V90.5h0c-.1-.2-.3.2-.3.2h0c0-.1-.1,0-.1.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M61.7,90.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M59.7,93.6h0v.2c.1,0,.1.1.1.2s-.1.4,0,.6H60a.9.9,0,0,0,.1.5c-.1,0,0,.3,0,.4h.5v.2h0v.7h0c-.2,0-.2.2-.3.3H60v.2h.9c.1,0,.5.4.6.3s-.1-.3-.1-.3l-.2-.2h-.1c-.1,0-.3,0-.2-.1h0c.1,0,.1,0,.1-.1a.3.3,0,0,0,.3-.3c.1,0,.1-.3.2-.3h.1l.2-.4h-.2v-.2c0-.1,0-.3.2-.3H62c.1-.1,0-.2.1-.3v-.2h0c0-.1-.1-.1,0-.3h-.1l.2-.3s-.1-.1,0-.1,0-.2.1-.2v-.5h0c.1-.1,0-.2,0-.3v-.3c0-.2-.1-.2-.1-.3h-.1c-.1,0,0,.1,0,.1h-.2l-.3-.2h-.8c-.4.7-1,1.5-1.5,2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M62.1,90.3a4.2,4.2,0,0,1,.2.6h-.9c-.1,0,0,.1,0,.1l.5.3.4.2h0v-.3h-.1c0-.1.4.2.5,0h.5c0-.1-.1-.4-.2-.4h-.3c-.7,0-.1-.8-.5-.9h0v-.4l-.4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M56.9,96.6a.3.3,0,0,1-.1.2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M58.7,94.6h.2l.2.2c.1,0,.2-.1.3,0h.1c0-.1-.1-.1-.2-.1s0-.2-.1-.3,0-.3-.2-.2h-.1l-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M57.5,95.8h0v.2l.5-.6h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M57.2,96.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M57.2,96.3h0c-.1,0-.3.3-.2.4h.1c-.3,0-.3.7-.3.9s0,.1.1.1-.1.3,0,.4h0v.8c0,.1-.1.3,0,.4s.1.3.1.4h.1a.3.3,0,0,0-.1.2,1.1,1.1,0,0,0,.2.5l.2.3v.3c0,.1-.1.2,0,.3v.2c0,.2.1.3.1.5s.1,0,.1.1v.2h0c.1.1.1.2,0,.4h0c.1.1.1.2,0,.4h0c.1.1,0,.1,0,.2h.1v.5h0a.6.6,0,0,0,.1.4h0c0,.1,0,.4-.1.5v.3c.2,0,.3-.3.4-.5s.2-.1.2-.3v-.3h.5a.6.6,0,0,0,.5-.2h-.9c0-.2,0-.3.1-.4s-.1-.4,0-.5.1-.2.1-.3-.1-.3-.1-.4a.5.5,0,0,1,.2-.4v-.4c0-.1-.1-.3-.1-.4v-1.3c-.1-.2.1-.3,0-.5h-.6c-.2,0-.2-.3-.3-.4h0c-.1,0-.2,0-.2-.2h.2v-.2h0a.2.2,0,0,1,0-.3h.5c.2,0,.3.2.5.1s.1-.4.1-.5h0a.4.4,0,0,1-.1-.3H59c0-.2.1-.3.1-.4l-.2-.3v-.3h-.2v-.4h-.7l-.5.6Zm.4.6v-.2h-.1c0-.1-.1-.1-.1-.2l.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M61.8,97.9h-.1c-.1,0-.4.4-.4.5L61,98h0l-.2.3h.4c.2,0,.2-.3.5-.3s.1.3.3.3.2-.1.3-.2v-.2h.3c-.2,0-.1-.3-.2-.3h0c0,.1-.1.1-.1,0l-.3.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "62.4 97.6 62.4 97.6 62.4 97.6 62.4 97.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M68.3,91.9l.4.3h.1c0,.1.1.2.2.3s0,.2.2.3-.2.4-.4.5a.4.4,0,0,1-.1.3h.4l.4-.2H71c-.1,0-.1-.2-.2-.3v-.2h-.3s-.2,0-.2-.1H70c0-.2-.2-.2-.3-.1s.1-.4.1-.6.1-.2.1-.3v-.2h0a.7.7,0,0,1,.1-.5H70c0-.1.2-.2.2-.4s-.1-.2-.1-.3.2-.2.2-.3-.1-.3-.1-.5a.4.4,0,0,0,.1-.3l.4-.2.3-.2h.3c.1-.1.1-.1.1-.2h-.1c-.2,0-.2-.1-.3-.2h-.6c0,.1-.2.1-.3.1v-.5c-.1-.2-.1-.4-.2-.5s0-.4-.2-.5h-.8l-.4.3h.3c-.3.1-.2.2-.3.4h0a.3.3,0,0,1-.1.2.8.8,0,0,0-.1.4h-.1c.1.1-.1.3-.3.3h-.1V90c-.1.2-.3.3-.3.5v.2c0,.1-.1.2,0,.3a.2.2,0,0,1,.2.2.4.4,0,0,1,.1.3l.3.3A.1.1,0,0,0,68.3,91.9Zm.1-1.3Zm0-1.8c.1-.2.1-.7.3-.9a.1.1,0,0,0,.1-.1h.7c.1.1,0,.2,0,.3a1.3,1.3,0,0,1-.2.9h0v-.4c0-.2.1-.3.1-.5h0v.4l-.3.5h-.1a.5.5,0,0,1,.2-.4.4.4,0,0,1,.1-.3h.1c-.2,0-.2.2-.3.3h0l-.3.4h-.1v-.2l-.2.5h-.1C68.3,89,68.4,88.9,68.4,88.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M60.4,98.4h.2l-.2-.3v-.3l-.3.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M64,98.1h0v-.2h-.8v.2C63.2,98.2,63.9,98.1,64,98.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M59.8,98.4h0a1,1,0,0,0-.4-.5.4.4,0,0,0,.1.3C59.5,98.3,59.6,98.7,59.8,98.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M64.1,97.9v.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M62.3,98.8H62v-.2H58.4c-.1,0,0,.1,0,.1h0a.1.1,0,0,0,.1.1h1l.6.3h0l-.2.4a.1.1,0,0,0,.2,0h0c0,.1-.1.2-.1.3h0c0,.3-.1.4-.1.6v.6h0l.2-.2H60c0-.3.1-.6.1-.9s.1-.2.2-.4h0v-.3c0-.2.1-.1.2,0s.1.3,0,.4v.2l.2.2a.4.4,0,0,0,.1.3h0v.2H61v-.2l-.2-.3c0-.1-.1-.9,0-.9h-.9l-.7-.2h-.4l1.1-.2h2a.9.9,0,0,1-.1.5h-1c.1.1.1.2.2.2h0c0,.1.1.3.1.4v.2h0c0-.1.1-.1.1-.2s-.2-.5,0-.4a.1.1,0,0,1,.1.1c.1.2.1.4.2.5s.1.3.2.5v.6a.3.3,0,0,1,.1.2H62a.9.9,0,0,0-.1-.5h.2l.5.3h.1v-.2h-.2l-.4-.4c-.1,0-.1-.1-.1-.2a.1.1,0,0,1-.1-.1l-.2-.5c0-.1-.1-.1-.1-.3h0c.2,0,.6.5.7.7h0a.7.7,0,0,0-.3-.6h-.1s-.1-.1,0-.1.2-.1.3-.1a.1.1,0,0,1,.1.1h.3c0,.1,0,.1.1.2h.2c0,.1.1.4.2.3s-.2-.4-.2-.5,0-.1,0-.1h0a.9.9,0,0,1-.5-.3h-.2v-.3h.4l.3-.2H63c.1,0,.2,0,.2-.1h-.6c-.1-.1.1-.3.2-.4s.1-.1.1-.2-.1-.1-.2-.1l-.3.6C62.3,98.6,62.3,98.7,62.3,98.8Zm-2.1.7h0ZM59,98.8h0Zm.2.1h0a.1.1,0,0,1-.1-.1h.1Zm1.6-.3h0Zm.2,1.1Zm.8-.1h0Zm.2-.8s-.1.1-.1,0Zm0,.7Zm.9-.9h0Zm-.1-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M62.8,99.1h-.3s.6-.1.6-.2h.1v-.2h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M62.7,99.6h0c.2,0,.3,0,.3-.2h0v.2h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M63,99.8h0c0,.1.2.1.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M59.9,100.7c0-.2,0-.3.1-.4h-.1a.2.2,0,0,1-.2.2h.1C59.8,100.7,59.8,100.7,59.9,100.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M60.4,100.6c0,.2-.1.7.3.6h0c-.2,0-.2-.3-.1-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M59.6,100.9v.2a.4.4,0,0,0-.1.3v.7c.1,0,.1,0,.1.1s.1-.3.1-.4-.1-.5,0-.7S59.7,100.9,59.6,100.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M61.8,102.6h-.2c-.1-.1,0-.2,0-.3a1.1,1.1,0,0,0,.1-.5h-.2l-.2-.2a.1.1,0,0,0-.1-.1h-.6c-.3,0-1,.7-.9.9h0c-.1,0-.1.4-.2.5s.2.1,0,.3v.2h-.1c0,.1.1.1.1.2s.1.4.2.6.1.2.1.3v.2h-.1a.5.5,0,0,1-.2.4h-.1l-.2.2h0c.1,0,.3-.2.4-.1h.2l.6.2h.1v-.2c-.3-.3-.3-.5,0-.7h.2a1.7,1.7,0,0,0,.3-.6c.1-.1-.1-.2-.1-.3h.2c.1,0,.1,0,.1-.1a.1.1,0,0,1,0-.2v-.3c.1-.2-.1-.2.1-.4a.1.1,0,0,1,.1-.1h.5v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M65.4,108.1h.1l.3-.4H66c0-.1,0-.2.1-.2s.4-.3.1-.5h0c-.1-.4.2-.3.3-.6s-.1-.4,0-.5H67l.5-.2.3-.2h.1c.1,0,0,.2,0,.3h0c.2,0,.5-.2.5-.3v-.2h-.9c-.1,0-.2,0-.2.1h-.2l-.3.3a.1.1,0,0,0-.1-.1,2.2,2.2,0,0,0-.1-.8c0-.1-.1-.1-.1-.2s.1-.2.1-.4v-.2h-.3a4.3,4.3,0,0,1,.1-.5v-.3c0-.2,0-.3-.1-.4h-.2v-.4h-.2a.4.4,0,0,1,.1-.3,1.3,1.3,0,0,0-.1-.6c0-.1-.1-.1-.1-.2h-.2c-.1,0-.2-.1-.2-.3s.2-.3.1-.6v-.4l-.2-.3v-.3l-.3-.2a4.3,4.3,0,0,0,.1-.5v-.3h0a.1.1,0,0,1,0-.2v-.2l.4-.5.2.2.5-.3h.8l.4-.4h.8c0-.2-.2-.1-.3-.1H66.7c.1.1,0,.1,0,0h-.1l-.4.2h0a.1.1,0,0,1-.1-.1h-.3a.2.2,0,0,0-.2.2h-.5c0,.2-.3.2-.4.3l-.5-.2H64a.1.1,0,0,0-.1-.1h0l-.4-.2-.4.2c-.3,0-.3.1-.5,0h0c0,.3-.5.1-.7.3v.2h1l.2.2h.6c.1-.1.3,0,.4.1H64c.1,0,.5-.1.4.1h.1a.1.1,0,0,1-.1.1v.4h0c.1,0,.1-.2.1-.2h.2c-.1,0-.1,0-.1.1h-.2a4.3,4.3,0,0,0-.1.5l-.4.3c0,.2,0,.3-.2.4s0,.2-.1.4,0,.1,0,.1h-.2c.1.2,0,.2,0,.4h-.1c-.1.1-.1.4-.1.5l-.3.4h0c.2.2,0,.5,0,.8v.2c-.1.1,0,.2-.1.4h0c-.2,0-.2.2-.1.3h0v-.2h.2v.2c-.1,0-.1.2-.1.2s-.2.3-.2.4v.2c.1,0,.1.1.1.2a.4.4,0,0,1-.1.3c-.1,0,0,.2,0,.3h-.2c0,.1.6.4.2.5h-.8c-.2-.2-.3-.1-.4-.1h-.4c-.1,0-.1.1-.1.2s0,.2.1.2H61l.6.2h.2l.2.3a1,1,0,0,0,.5.4.4.4,0,0,0,.1.3l.3.4a.6.6,0,0,1,.1.4c0,.1.1.2.1.3h.1c0,.2.1.2.2.4h.1a.4.4,0,0,0,.2.5H65a.4.4,0,0,1,.1-.3ZM62.2,96h0Zm-.7,9.1h-.3a.1.1,0,0,0-.1-.1h.6C61.7,105.2,61.6,105.1,61.5,105.1Zm.3.3c0-.1,0-.1-.1-.1h-.1c.1,0,.3,0,.3.1Zm.5,0c.1.1,0,.2-.1.2Zm-.2.1Zm.4.6-.3-.3h0C62.3,105.8,62.6,105.9,62.5,106.1Zm.2-2.5h0c-.1,0,0-.1,0-.1h0Zm3.6-.2v0Zm-.3.4v.3C65.9,104.1,66,103.8,66,103.8Zm-.1.6a.4.4,0,0,1-.1.3h0C65.8,104.6,65.9,104.5,65.9,104.4Zm-.1.4c.1.1,0,.3-.1.5h0C65.7,105.1,65.8,104.9,65.8,104.8Zm-.1-1a.2.2,0,0,1,0,.3h0C65.6,104.1,65.7,103.8,65.7,103.8Zm0,.4h0Zm0,1.2c-.1,0-.1.1-.1.2h0S65.6,105.4,65.7,105.4Zm-.9,1.9h0v-.2l.4-.5a4.3,4.3,0,0,1,.1-.5C65.4,106.2,64.9,107.1,64.8,107.3Zm.4-.2c-.1,0,0-.2,0-.2Zm-.1.1v.2C65,107.4,65.1,107.2,65.1,107.2Zm-.1.5h-.2l.2-.3h0Zm0,.1Zm0-1.2c0-.2,0-.6.1-.7h0c0,.3-.1.5-.1.7Zm.2.1a1.4,1.4,0,0,0,.2-.6c.1-.1.1-.3.2-.5s-.1.6-.2,1-.1.1-.2.2Zm.4-1.6h0c0,.1-.1.2-.1.3v.5h0A2.4,2.4,0,0,1,65.6,105.1Zm-.1-.1v-.2h0c0,.1-.1.1-.1.2Zm.1-.6v.4h0c-.1-.1-.1-.1-.1-.2h-.1v-.4c0-.1,0-.2.1-.2v-.3a.9.9,0,0,1,0,.7h.1Zm0-1.7v.4h0C65.4,103.1,65.5,102.7,65.6,102.7Zm0,.7h-.1v0Zm-.2-1.5h0c-.2.2-.1.6,0,.8a.5.5,0,0,0,0,.6c0,.1-.1.2,0,.4h0c.1,0,.1-.2.2-.3h0a.5.5,0,0,1-.2.4h-.2c0-.1.2-.6,0-.6h0v-.9a.4.4,0,0,1,.1-.3c0-.2-.1-.4-.1-.6v-.5c.1.2,0,.3,0,.5h.1A.8.8,0,0,1,65.4,101.9Zm-.4,1.8a.8.8,0,0,1,.2-.4c0,.1-.1.2-.1.3v.4c0,.1-.1.2-.1.4h0a.9.9,0,0,1,.1-.5Zm0,1.5v-.5a.6.6,0,0,0,.1-.4.4.4,0,0,1,.1-.3v.2a4.3,4.3,0,0,1-.1.5,3.4,3.4,0,0,0-.1,1H65Zm.3-5.4c0,.2-.1.2-.1.3h0c0-.1,0-.1-.1-.2s.1-.1,0-.2v-.4C65.1,99.4,65.3,99.8,65.3,99.8Zm-.2-1.1h0c-.1.1-.2.1-.2.2h-.1a.1.1,0,0,1,.1-.1h.2Zm-.3,6.6c0-.2.1-.5.1-.7a7.6,7.6,0,0,1-.1,1.5v-.8ZM64.7,99h.2c0,.1-.2,0-.2,0h0Zm-.1,1.3h0V100C64.7,100.1,64.6,100.2,64.6,100.3Zm0,.1v.5h0C64.5,100.9,64.5,100.5,64.6,100.4Zm-.1,1.9v-.4c0-.1.1-.1.1-.2a1.1,1.1,0,0,1-.1.8v.2h0Zm-.1,1.2c.1-.2,0-.4.1-.6h0v.2c0,.2-.1.5,0,.6h.1c0-.2.1-.3.1-.4v-.6a.4.4,0,0,1,.1-.3v-.2a.4.4,0,0,0,.1-.3,1.6,1.6,0,0,1-.2,1c0,.2.1.3.1.4s-.1.2-.1.3v.2c0,.2-.2.4-.1.6v.2h0l-.2-.3C64.3,104.2,64.4,103.8,64.4,103.5Zm.3,2.7v.2h0Zm-.3-.9h0v-.5a.4.4,0,0,1,0,.5Zm.1,1.9v-.8c.1,0,0,.7,0,.8v.5h-.1v-.3Zm0-1.6v.2h0Zm0,.4v0Zm0-.4h0v-.4C64.6,105.3,64.5,105.5,64.5,105.6Zm.1-.8v.3h0C64.5,105.1,64.6,104.8,64.6,104.8Zm-.2.8v.5a1.3,1.3,0,0,1-.1.6h0v-.6A1.3,1.3,0,0,1,64.4,105.6Zm-.2-.3c.1.2,0,.5,0,.7h0c-.1-.2,0-.3,0-.5Zm0-.6v-.2C64.3,104.6,64.3,104.7,64.2,104.7Zm0,.1h0Zm-.2,2.3h0c-.1,0,0-.3,0-.4a1.7,1.7,0,0,1,.1.7H64Zm0-3.2c.1.2,0,.3,0,.5h0Zm0-.2h0Zm0,1.5h0v-.7C64.1,104.7,64,105,64,105.2Zm0,.1h0Zm0,1v-.9a2.5,2.5,0,0,1,.1.9Zm0-2.6h0v-.8A2.2,2.2,0,0,1,64,103.7Zm0-.9v0Zm-.1-2.3h0c.1.1,0,.3,0,.4h0Zm-.1.2Zm-.1.1h.1c0,.1.1.2.1.3a.6.6,0,0,1-.1.4h0C63.7,101.7,63.7,101,63.7,100.8Zm0,1.7h0l.2.4h-.1S63.6,102.6,63.7,102.5Zm0-.1h0Zm-.1-.1c.1,0,.2-.2.2-.3v.2h0c0,.1-.1,0,0,.2h-.2Zm0,1.2h0c0-.2.1-.3.2-.5s-.1.3-.1.5.1.1.1.3-.3.4.1.5v.2h-.1v-.2h-.1a1.3,1.3,0,0,1,.1.6h0c0-.2-.2-.4-.2-.5V104a.4.4,0,0,0,.1-.3C63.7,103.6,63.7,103.5,63.6,103.5Zm.1,1.7h-.1a.1.1,0,0,1,.1-.1Zm-.1,0h.2v.5c.1.2,0,.3,0,.4a.4.4,0,0,0,.1.3h0c-.1-.1-.1-.1-.1-.2h-.1c0-.2,0-.6-.1-.7h-.1Zm0,.8c.1.2,0,.4.2.6h0a1,1,0,0,1,.1.3v.7h0c0-.1-.1-.2-.1-.4v-.4h0c-.1,0-.1.2-.1.3h0c-.1,0,0-.2,0-.2l-.3-1.5h0c-.1.2,0,.3,0,.5h0c0-.1-.1-.2-.1-.3v-.3a.4.4,0,0,1-.1-.3v-.4c0-.2-.1-.3-.1-.5h.1v-.3h0c.2.2,0,.6,0,.9l.3.7A4.3,4.3,0,0,1,63.6,106Zm0-4.7-.2.3h0Zm-.1.3c.1.1-.1.3-.2.4S63.4,101.7,63.5,101.6Zm-.1.5h0Zm-.1.1c0,.1-.1.4-.2.4h0C63.1,102.4,63.3,102.4,63.3,102.2Zm-.2.9c0-.2.2-.3.3-.5a.1.1,0,0,1-.1.1c0,.2-.1.3-.1.4s.2.6.1.7h-.1c0-.1,0-.5-.1-.5h0Zm1.7,5.3-.4.2-.2-.2c-.1,0-.2,0-.2-.1h-.2c0-.1-.1-.2-.2-.3v-.2l-.3-.8c-.1-.3-.1-.6-.2-.9v-.3c0-.1-.1-.3-.1-.4h0l.2.3h0c-.1,0-.1-.6-.1-.7h0c-.1,0-.1.3-.1.3h0v-.9h.1v.2a.4.4,0,0,1,.1.3c0,.2,0,.3.1.4s.1.3.1.4a.4.4,0,0,1,.1.3v.4l.2.3a2.1,2.1,0,0,0,.4,1.1.1.1,0,0,0,.1.1.1.1,0,0,0,0-.2h.1a.4.4,0,0,0-.1-.3h0c.4,0,.1-.7.1-.9h.1v.6h0c-.1.1,0,.3-.1.3h0c.1,0,.1.2.1.2h.2c.1,0,.1-.2.1-.3v-.2a.6.6,0,0,0,.1-.4v-.6c.1-.1.1-.3.2-.5v-.2h.1a4.3,4.3,0,0,1,.1-.5.4.4,0,0,0,.1-.3h.1a1.9,1.9,0,0,1-.3.8H65a3.6,3.6,0,0,1-.2,1,.4.4,0,0,1-.1.3v.3c0,.2-.2.2-.2.4h.4l-.3.4h-.8l.2.2.4.2.4-.2c.1-.1.5-.8.4-.9h0l.3-.4v-.4l.3-.3a.4.4,0,0,1,.1-.3v-.5a.3.3,0,0,0,.1-.2v-.3c0-.1.1-.1.1-.2a.6.6,0,0,0,.1-.4c0-.2-.2-.2,0-.5v1.2c0,.2,0,.3-.1.4s-.1.2-.1.4a.4.4,0,0,0-.1.3c-.1.1-.1.2-.2.2v.3l-.2.2a4.3,4.3,0,0,0-.1.5l-.2.2a1.4,1.4,0,0,1-.2.6l-.2.2C64.9,108.3,64.8,108.3,64.8,108.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M64.5,104.4h0c0-.2.2-.4,0-.6v.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M66.1,105.4c.1,0,.2-.5.1-.6s-.1.4-.1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M63.3,106.5a3.2,3.2,0,0,0-.3-.9,4.3,4.3,0,0,0,.1.5c.1.2.1.5.2.7h.1C63.4,106.8,63.3,106.6,63.3,106.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M65.8,106.1h.1c0-.1.1-.1,0-.3a.4.4,0,0,1-.1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M65.8,106.1l-.3.6h.1A1.4,1.4,0,0,1,65.8,106.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M65.5,106.9l-.2.3h0A.4.4,0,0,0,65.5,106.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M63.4,107h-.1a.4.4,0,0,1,.1.3l.2.3v.3h0c.2-.1-.2-.6-.2-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M65.3,107.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M100.9,87.6l-.5.6a.8.8,0,0,1-.2.5,1.3,1.3,0,0,1-.1.6h-.4l-.3.2h.1c0,.2-.1.3-.1.5s-.4.6-.4.8a.6.6,0,0,1-.1.4c-.2.2-.3,0-.5.1s-.4.2-.5.3h-.5a1.5,1.5,0,0,0-.5.6h-.1l1.3.6h.6a1.5,1.5,0,0,1,.3.7l-.2.3v.3c0,.1-.1.1-.1.2a2.4,2.4,0,0,0,.2.9c.1.1.1.3.2.4s0,.6.1.9l.3.4c.1.4-.2.7-.1,1.1a1.5,1.5,0,0,0,.6.5h0c-.1.3.2.5.4.6v.7l.6.9c.1.1.1.3.2.5h.4c0,.3.3.5.4.7l.4.3h.1a2.9,2.9,0,0,0,.3,1c.2.3.6.6.7,1h0c-.1.2-.5.2-.7.3s-.4.1-.7.4h0c0-.1.3.1.4.1h.1a1.4,1.4,0,0,0,.9-.1c.1-.1.1-.3.2-.3l.4.2,1,.2c.2,0,.1-.3.1-.4h-.2l-.3-.2c-.3-.2-.4-.1-.4-.5h0a.8.8,0,0,1,.2-.5l.3-.5a7.6,7.6,0,0,1,.4-1.1c0-.2-.1-.3,0-.5l.2-.3v-.3l.3-.2c0-.2-.1-.5,0-.7s.1-.2.1-.2a7.7,7.7,0,0,1,.2-1.5l.3-.5h-.1s-.3.4-.4.2h-.1s-.5.8-.6.8h-.4c0-.2.1-.4.1-.6v-.2h.1c.1-.2.2-.3.2-.5l.3-.2a.4.4,0,0,1,.1-.3l.4-.5c.2-.4,0-.9,0-1.3a4.3,4.3,0,0,0,.1-.5l-.3-.3c-.1-.2-.1-.5.1-.6s.3.4.4.6l.2.3h0a.1.1,0,0,0,.1-.1l-2-3v.4h-.2s-.1.2,0,.2h-.2c0-.1-.2-.1-.3-.1s-.4.2-.6.4.5.2.6.3,0,.3-.2.4h0c.3,0,.6.4.4.6l-.3.2h-.2c-.2,0-.7-.2-.8-.1h-.7c-.5,0-.5.5-.9,0a.2.2,0,0,1-.2-.2c0-.5.8-.3.7-.8a1.2,1.2,0,0,0-.5-.7l-.5-.3h-.2c-.1,0-.2-.3-.2-.5l.2-.2.2-.3c.4-.2,1.1-.1,1.1-.9s0-.3-.1-.4h-.1v-.3h.1c0-.1-.1-.3,0-.4s.1-.2.2-.4.1-.3.2-.4l-1-1.3h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M99.7,108.4c0-.1.1-.2.1-.4l.3-.9v-.6a1.4,1.4,0,0,1,.2-.7.5.5,0,0,1,.4-.2l.5-.2a.9.9,0,0,0-.3-.6h0a.1.1,0,0,0-.1.1l-.2-.2h-.3c-.2,0-.4-.3-.4-.5V104a.8.8,0,0,1-.2-.4c-.1-.2,0-.2,0-.4v-.5h-.3c-.5-.3-.1-.5-.2-1l-.2-.4c-.1-.4.1-.5-.3-.6v-.2c-.2-.2-.5-.3-.3-.6h.1c-.2,0-.4-.6-.6-.7l-.7-.4-.4.2c-.3.2-.2.5-.7.3h-.1c0,.1.1.2.2.3h-.5c-.1,0-.2.4-.5.5s.1.1.1.2h-.4c-.1,0-.2.3-.2.4h.4a.1.1,0,0,0-.1.1l-.5.2h0c.1,0,.1.2.1.2a.6.6,0,0,0-.1.4c-.1.4-.1.2-.4.1h0a6.2,6.2,0,0,0,.1,1.3h-.1c-.4,0-.7.1-.8.5s0,.3,0,.4l.4.2.3.2a.5.5,0,0,0,.2.4h.4a.2.2,0,0,1-.1.3v.3c.2,0,.5.8.5,1H95l.3.2v.2c-.1.2.1.4.1.6h0a.1.1,0,0,1,.1-.1c.4,0,.2.6.2.9h3.7c0-.1,0-.1.1-.1h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M80.6,98.1a.1.1,0,0,1,.1.1c-.2-.1-.3.2-.4.3s-.1.2-.1.4h1c0-.3.1-.6.1-.9l.6-1a4.3,4.3,0,0,0-.2-1.1c-.2,0-.5.7-.6.9s-.4,0-.6-.1l.3-1.5C79.5,96.1,80.3,97,80.6,98.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M77.5,98.9a1.5,1.5,0,0,0,.1,1.6h0C78.4,100.9,78.3,99.3,77.5,98.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M82.4,101,80,99.6a3.9,3.9,0,0,1-.8,1A19.7,19.7,0,0,0,77,102l-.2.3c-1.3.7-.6-1.2-.7-1.8a1.8,1.8,0,0,0-.6-.9c-.2-.2-.3-.4-.6-.4s-.1,2.3-.2,2.9h0l-.6-.2v-.5c-.7-.2-.8.8-1.5.8s-1.3-1.1-1.8-1.4l.4-.4h-.8a1.8,1.8,0,0,1-.7.8l-.7-.3c-1.5-.9.2-2.5-1.2-3.6l-.5.5c.1,0,.1.3.2.5s-.3,2,0,3a3.7,3.7,0,0,0,2,1.9,7.5,7.5,0,0,0,3.3,1.4l5.3-.8,1-1.9c0-.2.4,0,.6.1a9.4,9.4,0,0,1,1-1l1.4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M73.2,98.7h-.1c-.1.4-.3,2,.5,1.8S73.6,99,73.2,98.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M70.4,98.4c-.3,1,1.1,1.9,1.6.5l-1.2-.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngLogo2025);
export default __webpack_public_path__ + "static/media/eng_logo_2025.abd220037ac2d00e7cee3f9443569fc8.svg";
export { ForwardRef as ReactComponent };